import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "../../gmanewstyle.module.css";
import logoimage from "../assets/Group -2.png";
import { format } from "date-fns";
import { useLocation } from "react-router-dom";
import PortalSidebar from "../PortalSidebar/PortalSidebar";

const DASHBOARD_PIE_COLOURS = Object.freeze({
  cardinal: "#950010",
  blue: "#234E70",
  steel: "#4A4A4A",
  coolGrey: "#E6E6E6",

  // Brand-derived tints for charts with more than four slices.
  blueTint: "#65839B",
  cardinalTint: "#B54D58",
  steelTint: "#808080",
  coolGreyTint: "#F2F2F2",
});

const DASHBOARD_PIE_SEQUENCE = Object.freeze([
  DASHBOARD_PIE_COLOURS.blue,
  DASHBOARD_PIE_COLOURS.cardinal,
  DASHBOARD_PIE_COLOURS.steel,
  DASHBOARD_PIE_COLOURS.coolGrey,
  DASHBOARD_PIE_COLOURS.blueTint,
  DASHBOARD_PIE_COLOURS.cardinalTint,
  DASHBOARD_PIE_COLOURS.steelTint,
  DASHBOARD_PIE_COLOURS.coolGreyTint,
]);

const DASHBOARD_STATISTICS_COLOURS = Object.freeze({
  "Active - Client Adhering": DASHBOARD_PIE_COLOURS.blue,
  "Cancelled / Not Adhered": DASHBOARD_PIE_COLOURS.cardinal,
  "Completed Successfully": DASHBOARD_PIE_COLOURS.blueTint,
  "In Progress": DASHBOARD_PIE_COLOURS.steel,
  Other: DASHBOARD_PIE_COLOURS.coolGrey,
  "New Files": DASHBOARD_PIE_COLOURS.blueTint,
  "Closed Successfully": DASHBOARD_PIE_COLOURS.blue,
  "Closed Other": DASHBOARD_PIE_COLOURS.cardinal,
  "Created The FY": DASHBOARD_PIE_COLOURS.blueTint,
  "Closed The FY": DASHBOARD_PIE_COLOURS.blue,
});

// Helper function for fetch calls with auth token
const fetchWithToken = async (endpoint, token) => {
  const response = await fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return response.json();
};

const formatAmount = (amount) =>
  Number(amount)
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, "\u2002");

// Updated date formatting helper that checks for an invalid date.
// You can optionally pass a custom format string.
const formatDate = (rawDate, fmt = "dd MMM yyyy hh:mm") => {
  const date = new Date(rawDate);
  if (isNaN(date.getTime())) return rawDate;
  return format(date, fmt);
};

// Reusable Pagination component
const Pagination = ({
  currentPage,
  setCurrentPage,
  totalRecords,
  recordsPerPage,
}) => {
  const startIndex = (currentPage - 1) * recordsPerPage;
  const endIndex = Math.min(startIndex + recordsPerPage, totalRecords);
  return (
    <div className={styles.pagination}>
      <button
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
        className={`${styles.pageBtn} ${styles.pageBtnPrimary}`}
      >
        Previous
      </button>
      <span className={styles.pageMeta}>
        {startIndex + 1} - {endIndex} of {totalRecords}
      </span>
      <button
        onClick={() => setCurrentPage(currentPage + 1)}
        disabled={endIndex >= totalRecords}
        className={`${styles.pageBtn} ${styles.pageBtnPrimary}`}
      >
        Next
      </button>
    </div>
  );
};
// Generic SubTabSelector component for sub-tabs
const SubTabSelector = ({ tabs, activeTab, onSelect }) => (
  <div className={styles.subTabs}>
    {tabs.map((tab) => (
      <div
        key={tab}
        className={activeTab === tab ? styles.subTabActive : styles.subTab}
        onClick={() => onSelect(tab)}
      >
        {tab}
      </div>
    ))}
  </div>
);

// Ã°Å¸â€ â€¢ Trustee-specific SubTabSelector
const TrusteeSubTabSelector = ({ tabs, activeTab, onSelect }) => (
  <div className={styles.subTabs}>
    {tabs.map((tab) => (
      <div
        key={tab}
        className={activeTab === tab ? styles.subTabActive : styles.subTab}
        onClick={() => onSelect(tab)}
      >
        {tab}
      </div>
    ))}
  </div>
);

const BuildingInfoPage = () => {
  // Get information from localStorage and URL parameters.
  const [showTicketModal, setShowTicketModal] = useState(false);
  const contactId = localStorage.getItem("contact_id");
  const navigate = useNavigate();
  const { building_guid } = useParams();
  const location = useLocation();
  const storageKey = `buildingInfoState_${building_guid}`;
  const [accessChecked, setAccessChecked] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);
  // read what was in sessionStorage (or fall back to {})
  const getSaved = () => {
    try {
      return JSON.parse(sessionStorage.getItem(storageKey)) || {};
    } catch {
      return {};
    }
  };
  const saved = getSaved();

  // State definitions
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [buildingName, setBuildingName] = useState("");
  const [ageUpdatedToDate, setAgeUpdatedToDate] = useState("");
  const [documents, setDocuments] = useState([]);
  const [data, setData] = useState(null);
  const [maintData, setMaintData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [trusteesData, setTrusteesData] = useState(null);
  const [trusteeDetails, setTrusteeDetails] = useState({});
  const [trusteeSubTab, setTrusteeSubTab] = useState("all");
  const [trusteeFilterName, setTrusteeFilterName] = useState("");
  const [trusteeFilterEmail, setTrusteeFilterEmail] = useState("");
  const [trusteeFilterMobile, setTrusteeFilterMobile] = useState("");
  const [trusteeCurrentPage, setTrusteeCurrentPage] = useState(1);
  const [filterPaymentPk, setFilterPaymentPk] = useState("");
  const [filterOurReference, setFilterOurReference] = useState("");
  const [filterPaymentType, setFilterPaymentType] = useState("");
  const [filterProgress, setFilterProgress] = useState("");
  const [filterDoorNumber, setFilterDoorNumber] = useState("");
  const [filterDisconnectionStatus, setFilterDisconnectionStatus] =
    useState("");
  const [disconnectionDateMode, setDisconnectionDateMode] = useState("single");
  const [disconnectionPendingDateFilter, setDisconnectionPendingDateFilter] =
    useState({ from: "", to: "" });
  const [disconnectionDateFilter, setDisconnectionDateFilter] = useState({
    from: "",
    to: "",
  });
  const [filterTicketType, setFilterTicketType] = useState("");
  const [filterTaskSubject, setFilterTaskSubject] = useState("");
  const [filterTaskProgress, setFilterTaskProgress] = useState("");
  const [publicTasksDateMode, setPublicTasksDateMode] = useState("single");
  const [publicTasksPendingDateFilter, setPublicTasksPendingDateFilter] =
    useState({ from: "", to: "" });
  const [publicTasksDateFilter, setPublicTasksDateFilter] = useState({
    from: "",
    to: "",
  });
  const [myTasksOnly, setMyTasksOnly] = useState(false);
  const [docFilterName, setDocFilterName] = useState("");
  const [docFilterDesignation, setDocFilterDesignation] = useState("");
  const [docCurrentPage, setDocCurrentPage] = useState(1);
  const docRecordsPerPage = 5;
  const [filterSageAcc, setFilterSageAcc] = useState("");
  const [filterDoorAcc, setFilterDoorAcc] = useState("");
  const [filterAccountType, setFilterAccountType] = useState("");
  const [filterBalance, setFilterBalance] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filterPaidTo, setFilterPaidTo] = useState("");
  const recordsPerPage = 10;
  const approvalsPerPage = 5;
  const [filterApprovalSubject, setFilterApprovalSubject] = useState("");
  const [filterApprovalType, setFilterApprovalType] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [debtorsDashboardData, setDebtorsDashboardData] = useState({
    balances: [],
    aods: [],
    legals: [],
    disconnections: [],
    statistics: null,
    correlation: null,
  });
  const [dashboardFinancialYear, setDashboardFinancialYear] =
    useState("current");
  const [landingData, setLandingData] = useState({
    tasks: [],
    balances: [],
    aods: [],
    legals: [],
    disconnections: [],
    maintenance: [],
  });
  const money = (value) => `R ${formatAmount(Number(value || 0))}`;
  const compactMoney = (value) =>
    new Intl.NumberFormat("en-ZA", {
      style: "currency",
      currency: "ZAR",
      notation: "compact",
      maximumFractionDigits: 1,
    }).format(Number(value || 0));

  const getFormatted = (item, field) =>
    item?.[`${field}@OData.Community.Display.V1.FormattedValue`] ||
    item?.[field] ||
    "";

  const sumBy = (list, field) =>
    list.reduce((sum, item) => sum + Number(item?.[field] || 0), 0);

  const groupDebtByUnit = (list = []) => {
    const numericFields = [
      "cj_agetotal",
      "cj_agecurrent",
      "cj_age30days",
      "cj_age60days",
      "cj_age90days",
      "cj_age120days",
      "cj_age150days",
      "cj_age180days",
    ];

    const grouped = new Map();

    list.forEach((account) => {
      const accountType = String(
        account?.["ab_accounttype@OData.Community.Display.V1.FormattedValue"] ||
          "",
      )
        .trim()
        .toLowerCase();

      // Dashboard debt is determined only from the unit's Owner and Tenant accounts.
      if (accountType !== "owner" && accountType !== "tenant") return;

      const unitId =
        account?._cj_unitname_value || account?.cj_UnitName?.cj_gmaunitsid;

      if (!unitId) {
        console.warn(
          "Debt aggregation skipped an account without a linked unit:",
          account?.cj_gmaaccountnumberid,
        );
        return;
      }

      const key = String(unitId).trim().toLowerCase();
      let unit = grouped.get(key);

      if (!unit) {
        unit = {
          unitId,
          cj_doornumber:
            account?.cj_doornumber || account?.cj_UnitName?.cj_unitname || "",
          accountCount: 0,
        };

        numericFields.forEach((field) => {
          unit[field] = 0;
        });

        grouped.set(key, unit);
      }

      numericFields.forEach((field) => {
        const value = Number(account?.[field]);
        if (Number.isFinite(value)) {
          unit[field] += value;
        }
      });

      unit.accountCount += 1;
    });

    return [...grouped.values()].map((unit) => ({
      ...unit,

      sum_age_120_180:
        unit.cj_age120days + unit.cj_age150days + unit.cj_age180days,

      // A unit is in arrears when its combined Owner + Tenant
      // balance from 30 days onward is positive.
      arrearsBalance:
        unit.cj_age30days +
        unit.cj_age60days +
        unit.cj_age90days +
        unit.cj_age120days +
        unit.cj_age150days +
        unit.cj_age180days,
    }));
  };

  const getDebtorsDashboardSummary = (dashboardData = {}) => {
    const balances = dashboardData.balances || [];
    const aods = dashboardData.aods || [];
    const legals = dashboardData.legals || [];
    const disconnections = dashboardData.disconnections || [];

    const unitBalances = groupDebtByUnit(balances);
    const arrearsUnits = unitBalances.filter(
      (unit) => Number(unit.arrearsBalance || 0) > 0,
    );

    const legalDebt = sumBy(legals, "cj_debtonhandover");

    const handedOverAccountCount = new Set(
      legals
        .map((legal) =>
          String(legal._cj_account_value || "")
            .trim()
            .toLowerCase(),
        )
        .filter(Boolean),
    ).size;

    const aodTarget = sumBy(aods, "cj_totalrequiredreceiptssincesignature");
    const aodReceipts = sumBy(aods, "cj_totalreceiptssincedateofsignature");

    return {
      unitBalances,
      totalDebt: sumBy(balances, "cj_agetotal"),
      currentDebt: sumBy(balances, "cj_agecurrent"),
      age30: sumBy(balances, "cj_age30days"),
      age60: sumBy(balances, "cj_age60days"),
      age90: sumBy(balances, "cj_age90days"),
      age120: sumBy(balances, "sum_age_120_180"),
      arrearsUnits,
      legalDebt,
      handedOverAccountCount,
      activeAodCount: aods.length,
      aodTarget,
      aodReceipts,
      aodShortfall: Math.max(aodTarget - aodReceipts, 0),
      activeDisconnected: disconnections.filter(
        (item) => getFormatted(item, "cj_status") === "Disconnected",
      ),
    };
  };

  const getMaintenanceProgress = (item) =>
    item?.["cj_progress@OData.Community.Display.V1.FormattedValue"] ||
    "Unknown";

  const getMaintenanceDashboardSummary = (dashboardData = {}) => {
    const active = dashboardData.active || [];
    const quoteJobs = dashboardData.quoteJobs || [];
    const allActiveJobs = [...active, ...quoteJobs];
    const now = new Date();

    return {
      allActiveJobs,
      totalInvoice: sumBy(allActiveJobs, "cj_invoiceamount"),

      overdueJobs: allActiveJobs.filter((item) => {
        if (!item.cj_dateofjobcompletion) return false;

        const completionDate = new Date(item.cj_dateofjobcompletion);

        return (
          !isNaN(completionDate.getTime()) &&
          completionDate < now &&
          getMaintenanceProgress(item) !== "Completed"
        );
      }),

      awaitingQuotes: quoteJobs.filter(
        (item) => !item.quotes || item.quotes.length === 0,
      ),
    };
  };

  const asList = (response) => response?.value || response || [];

  const fetchLanding = async (token) => {
    const tasksRes = await fetchWithToken(
      `https://portal.gmacc.co.za/api/building/${building_guid}/tasks/`,
      token,
    );

    setLandingData({
      tasks: asList(tasksRes),
    });
  };

  const fetchDebtorsDashboard = async (token) => {
    const financialYearQuery = `?financial_year=${encodeURIComponent(
      dashboardFinancialYear,
    )}`;
    const endpoints = {
      balances: `https://portal.gmacc.co.za/api/building/${building_guid}/balances/debtors/`,
      aods: `https://portal.gmacc.co.za/api/building/${building_guid}/aod/`,
      legals: `https://portal.gmacc.co.za/api/building/${building_guid}/legal/`,
      disconnections: `https://portal.gmacc.co.za/api/building/${building_guid}/disconnections/`,
      statistics: `https://portal.gmacc.co.za/api/building/${building_guid}/debtors-statistics/${financialYearQuery}`,
      correlation: `https://portal.gmacc.co.za/api/building/${building_guid}/debtors-correlation/${financialYearQuery}`,
    };

    const [
      balancesRes,
      aodsRes,
      legalsRes,
      disconnectionsRes,
      statisticsRes,
      correlationRes,
    ] = await Promise.all([
      fetchWithToken(endpoints.balances, token),
      fetchWithToken(endpoints.aods, token),
      fetchWithToken(endpoints.legals, token),
      fetchWithToken(endpoints.disconnections, token),
      fetchWithToken(endpoints.statistics, token),
      fetchWithToken(endpoints.correlation, token),
    ]);

    setDebtorsDashboardData({
      balances: balancesRes?.value || balancesRes || [],
      aods: aodsRes?.value || aodsRes || [],
      legals: legalsRes?.value || legalsRes || [],
      disconnections: disconnectionsRes?.value || disconnectionsRes || [],
      statistics: statisticsRes?.financial_year ? statisticsRes : null,
      correlation: correlationRes || null,
    });
  };

  // Default sidebar state based on device width
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 1024;
      setIsDesktop(desktop);

      // Only force closed when moving to smaller screens.
      // On desktop, keep whatever state the user last chose.
      if (!desktop) {
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    function handleClick(e) {
      // On desktop/laptop, only the burger should control the sidebar
      if (isDesktop) return;

      const sidebar = document.getElementsByClassName(styles.sidebar)[0];
      const hamburger = document.getElementsByClassName(styles.menuBtn)[0];

      if (!sidebar || !hamburger) return;

      const clickedInsideSidebar = sidebar.contains(e.target);
      const clickedHamburger = hamburger.contains(e.target);

      if (sidebarOpen && !clickedInsideSidebar && !clickedHamburger) {
        setSidebarOpen(false);
      }
    }

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [sidebarOpen, isDesktop]);

  const [activeTab, setActiveTab] = useState(saved.activeTab || "Landing");
  const [creditSubTab, setCreditSubTab] = useState(saved.creditSubTab || "AOD");
  const [maintSubTab, setMaintSubTab] = useState(
    saved.maintSubTab || "Active Maintenances",
  );
  const [approvalSubTab, setApprovalSubTab] = useState(
    saved.approvalSubTab || "Active",
  );

  useEffect(() => {
    const raw = sessionStorage.getItem(storageKey);
    if (!raw) return;
    try {
      const s = JSON.parse(raw);

      // 1) Always restore your tab/sub-tag selections
      if (s.activeTab) setActiveTab(s.activeTab);
      if (s.creditSubTab) setCreditSubTab(s.creditSubTab);
      if (s.maintSubTab) setMaintSubTab(s.maintSubTab);
      if (s.approvalSubTab) setApprovalSubTab(s.approvalSubTab);

      //  2) Always restore pagination
      if (typeof s.currentPage === "number") setCurrentPage(s.currentPage);
      if (typeof s.docCurrentPage === "number")
        setDocCurrentPage(s.docCurrentPage);
      if (typeof s.trusteeCurrentPage === "number")
        setTrusteeCurrentPage(s.trusteeCurrentPage);

      // 3) Restore only filters for the **active** tab/sub-tab

      // General Docs
      if (s.activeTab === "General") {
        setDocFilterName(s.docFilterName || "");
        setDocFilterDesignation(s.docFilterDesignation || "");
      }

      // Payments
      if (s.activeTab === "Payments") {
        setFilterPaymentPk(s.filterPaymentPk || "");
        setFilterOurReference(s.filterOurReference || "");
        setFilterPaidTo(s.filterPaidTo || "");
        setFilterPaymentType(s.filterPaymentType || "");
        setFilterProgress(s.filterProgress || "");
      }

      // Approvals
      if (s.activeTab === "Approvals") {
        setFilterApprovalSubject(s.filterApprovalSubject || "");
        setFilterApprovalType(s.filterApprovalType || "");
      }

      // Credit Control
      if (s.activeTab === "Credit Control") {
        if (s.creditSubTab === "Disconnections") {
          setFilterDoorNumber(s.filterDoorNumber || "");
          setFilterDisconnectionStatus(s.filterDisconnectionStatus || "");
          setDisconnectionDateMode(s.disconnectionDateMode || "single");
          setDisconnectionPendingDateFilter(
            s.disconnectionPendingDateFilter || { from: "", to: "" },
          );
          setDisconnectionDateFilter(
            s.disconnectionDateFilter || { from: "", to: "" },
          );
        }
        if (s.creditSubTab === "Balances") {
          setFilterSageAcc(s.filterSageAcc || "");
          setFilterDoorAcc(s.filterDoorAcc || "");
          setFilterAccountType(s.filterAccountType || "");
          setFilterBalance(s.filterBalance || "");
        }
      }

      // Tasks
      if (s.activeTab === "Tasks") {
        setFilterTicketType(s.filterTicketType || "");
        setFilterTaskSubject(s.filterTaskSubject || "");
        setFilterTaskProgress(s.filterTaskProgress || "");
        setPublicTasksDateMode(s.publicTasksDateMode || "single");
        setPublicTasksPendingDateFilter(
          s.publicTasksPendingDateFilter || { from: "", to: "" },
        );
        setPublicTasksDateFilter(
          s.publicTasksDateFilter || { from: "", to: "" },
        );
        setMyTasksOnly(
          typeof s.myTasksOnly === "boolean" ? s.myTasksOnly : false,
        );
      }

      // Trustees
      if (s.activeTab === "Trustees") {
        if (s.trusteeSubTab) setTrusteeSubTab(s.trusteeSubTab);
        setTrusteeFilterName(s.trusteeFilterName || "");
        setTrusteeFilterEmail(s.trusteeFilterEmail || "");
        setTrusteeFilterMobile(s.trusteeFilterMobile || "");
      }

      // Finance has no extra filters
    } catch (err) {
      console.warn("Could not restore buildingInfo state:", err);
    }
  }, [storageKey]);

  const approvalTypeOptions = [
    "AOD",
    "Payment",
    "Maintenance Quote Selection",
    "Conduct Letter",
    "Conduct Fine",
    "Budget",
    "Minutes",
    "Legal",
    "Maintenance work approval",
  ];

  const [userAccess, setUserAccess] = useState([]);
  const [loadingAccess, setLoadingAccess] = useState(true);

  /* Access (unchanged) */
  useEffect(() => {
    const fetchUserAccess = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/");
        return;
      }

      try {
        const decoded = JSON.parse(atob(token.split(".")[1]));
        const { email, contact_id, firstname, lastname, name } = decoded || {};

        // Set display name safely
        const fullName =
          firstname && lastname
            ? `${firstname} ${lastname}`
            : name
              ? name
              : email || "User";

        setDisplayName(fullName);

        if (!email) {
          setLoadingAccess(false);
          return;
        }

        const resp = await fetch(
          "https://portal.gmacc.co.za/api/contact/determine-access/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ email, contact_id }),
          },
        );

        const data = await resp.json();
        if (resp.ok) {
          setUserAccess(data.access || []);
        }
      } catch (err) {
        console.error("Failed to fetch access:", err);
      } finally {
        setLoadingAccess(false);
      }
    };

    fetchUserAccess();
  }, [navigate]);


  const primaryTabs = [
    "Landing",
    "Dashboards",
    "Approvals",
    "General",
    "Other",
  ];
  const dashboardTabs = ["Debtors Dashboard", "Maintenance Dashboard"];
  const otherTabs = [
    "Payments",
    "Credit Control",
    "Maintenance",
    "Tasks",
    "Trustees",
    "Finance",
  ];
  const creditSubTabs = ["AOD", "Legal", "Disconnections", "Balances"];

  const validateAccess = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        "https://portal.gmacc.co.za/api/access/check-building/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ building_guid }),
        },
      );
      const result = await res.json();
      if (res.ok && result.access) {
        setHasAccess(true);
      } else {
        alert("You do not have access to view this building.");
        navigate("/");
      }
    } catch (err) {
      console.error("Access validation failed", err);
      alert("Failed to check access.");
      navigate("/");
    } finally {
      setAccessChecked(true);
    }
  };
  const [displayName, setDisplayName] = useState("");
  const [maintenanceDashboardData, setMaintenanceDashboardData] = useState({
    active: [],
    history: [],
    quoteJobs: [],
    glAccounts: [],
    majorCapitalAccounts: [],
    financialYear: null,
    contractorPaidTotals: {},
  });

  const fetchMaintenanceDashboard = async (token) => {
    const financialYearQuery = `?financial_year=${encodeURIComponent(
      dashboardFinancialYear,
    )}`;
    const toArray = (response) => {
      if (Array.isArray(response?.value)) return response.value;
      if (Array.isArray(response)) return response;
      return [];
    };

    const [activeRes, historyRes, quoteJobsRes, glAccountsRes] =
      await Promise.all([
        fetchWithToken(
          `https://portal.gmacc.co.za/api/building/${building_guid}/maintenances/${financialYearQuery}`,
          token,
        ),
        fetchWithToken(
          `https://portal.gmacc.co.za/api/building/${building_guid}/maintenances/inactive/`,
          token,
        ),
        fetchWithToken(
          `https://portal.gmacc.co.za/api/building/${building_guid}/maintenances2/`,
          token,
        ),
        fetchWithToken(
          `https://portal.gmacc.co.za/api/building/${building_guid}/maintenance-gl-accounts/${financialYearQuery}`,
          token,
        ),
      ]);

    const quoteJobs = await Promise.all(
      toArray(quoteJobsRes).map(async (job) => {
        try {
          const quotesRes = await fetchWithToken(
            `https://portal.gmacc.co.za/api/maintenance/${job.cj_maintenancebid}/quotes/`,
            token,
          );

          return {
            ...job,
            quotes: toArray(quotesRes),
          };
        } catch {
          return {
            ...job,
            quotes: [],
          };
        }
      }),
    );

    setMaintenanceDashboardData({
      active: toArray(activeRes),
      history: toArray(historyRes),
      quoteJobs,
      glAccounts: toArray(glAccountsRes),
      contractorPaidTotals: activeRes?.contractor_paid_totals || {},
      majorCapitalAccounts: Array.isArray(glAccountsRes?.major_capital)
        ? glAccountsRes.major_capital
        : [],
      financialYear: glAccountsRes?.financial_year || null,
    });
  };

  useEffect(() => {
    validateAccess();
  }, [building_guid]);
  useEffect(() => {
    const saved = sessionStorage.getItem(storageKey);
    if (!saved) return;
    try {
      const s = JSON.parse(saved);

      // Tabs
      if (s.activeTab) setActiveTab(s.activeTab);
      if (s.creditSubTab) setCreditSubTab(s.creditSubTab);
      if (s.maintSubTab) setMaintSubTab(s.maintSubTab);
      if (s.approvalSubTab) setApprovalSubTab(s.approvalSubTab);

      // Pagination
      if (s.currentPage) setCurrentPage(s.currentPage);
      if (s.docCurrentPage) setDocCurrentPage(s.docCurrentPage);
      if (s.trusteeCurrentPage) setTrusteeCurrentPage(s.trusteeCurrentPage);

      // General tab filters
      if (s.docFilterName) setDocFilterName(s.docFilterName);
      if (s.docFilterDesignation)
        setDocFilterDesignation(s.docFilterDesignation);

      // Payments tab filters
      if (s.filterPaymentPk) setFilterPaymentPk(s.filterPaymentPk);
      if (s.filterOurReference) setFilterOurReference(s.filterOurReference);
      if (s.filterPaidTo) setFilterPaidTo(s.filterPaidTo);
      if (s.filterPaymentType) setFilterPaymentType(s.filterPaymentType);
      if (s.filterProgress) setFilterProgress(s.filterProgress);

      // Credit Control Disconnections filters
      if (s.filterDoorNumber) setFilterDoorNumber(s.filterDoorNumber);
      if (s.filterDisconnectionStatus)
        setFilterDisconnectionStatus(s.filterDisconnectionStatus);
      if (s.disconnectionDateMode)
        setDisconnectionDateMode(s.disconnectionDateMode);
      if (s.disconnectionPendingDateFilter)
        setDisconnectionPendingDateFilter(s.disconnectionPendingDateFilter);
      if (s.disconnectionDateFilter)
        setDisconnectionDateFilter(s.disconnectionDateFilter);

      // Tasks tab filters
      if (s.filterTicketType) setFilterTicketType(s.filterTicketType);
      if (s.filterTaskSubject) setFilterTaskSubject(s.filterTaskSubject);
      if (s.filterTaskProgress) setFilterTaskProgress(s.filterTaskProgress);
      if (s.publicTasksDateMode) setPublicTasksDateMode(s.publicTasksDateMode);
      if (s.publicTasksPendingDateFilter)
        setPublicTasksPendingDateFilter(s.publicTasksPendingDateFilter);
      if (s.publicTasksDateFilter)
        setPublicTasksDateFilter(s.publicTasksDateFilter);
      if (typeof s.myTasksOnly === "boolean") setMyTasksOnly(s.myTasksOnly);

      // Credit Control Balances filters
      if (s.filterSageAcc) setFilterSageAcc(s.filterSageAcc);
      if (s.filterDoorAcc) setFilterDoorAcc(s.filterDoorAcc);
      if (s.filterAccountType) setFilterAccountType(s.filterAccountType);
      if (s.filterBalance) setFilterBalance(s.filterBalance);

      // Approvals tab filters
      if (s.filterApprovalSubject)
        setFilterApprovalSubject(s.filterApprovalSubject);
      if (s.filterApprovalType) setFilterApprovalType(s.filterApprovalType);

      // Trustees tab state & filters
      if (s.trusteeSubTab) setTrusteeSubTab(s.trusteeSubTab);
      if (s.trusteeFilterName) setTrusteeFilterName(s.trusteeFilterName);
      if (s.trusteeFilterEmail) setTrusteeFilterEmail(s.trusteeFilterEmail);
      if (s.trusteeFilterMobile) setTrusteeFilterMobile(s.trusteeFilterMobile);
    } catch (e) {
      console.warn("Could not restore buildingInfo state", e);
    }
  }, [storageKey]);

  // 4) On any of those states changing: save back out
  useEffect(() => {
    const toSave = {
      activeTab,
      creditSubTab,
      maintSubTab,
      approvalSubTab,
      building_guid,
      dashboardFinancialYear,
      currentPage,
      docCurrentPage,

      // General tab filters
      docFilterName,
      docFilterDesignation,

      // Payments tab filters
      filterPaymentPk,
      filterOurReference,
      filterPaidTo,
      filterPaymentType,
      filterProgress,

      // Credit Control Disconnections filters
      filterDoorNumber,
      filterDisconnectionStatus,
      disconnectionDateMode,
      disconnectionPendingDateFilter,
      disconnectionDateFilter,

      // Tasks tab filters
      filterTicketType,
      filterTaskSubject,
      filterTaskProgress,
      publicTasksDateMode,
      publicTasksPendingDateFilter,
      publicTasksDateFilter,
      myTasksOnly,

      // Credit Control Balances filters
      filterSageAcc,
      filterDoorAcc,
      filterAccountType,
      filterBalance,

      // Approvals tab filters
      filterApprovalSubject,
      filterApprovalType,

      // Trustees tab state & filters
      trusteeSubTab,
      trusteeFilterName,
      trusteeFilterEmail,
      trusteeFilterMobile,
      trusteeCurrentPage,
    };

    sessionStorage.setItem(storageKey, JSON.stringify(toSave));
  }, [
    activeTab,
    creditSubTab,
    maintSubTab,
    approvalSubTab,
    currentPage,
    docCurrentPage,

    docFilterName,
    docFilterDesignation,

    filterPaymentPk,
    filterOurReference,
    filterPaidTo,
    filterPaymentType,
    filterProgress,

    filterDoorNumber,
    filterDisconnectionStatus,
    disconnectionDateMode,
    disconnectionPendingDateFilter,
    disconnectionDateFilter,

    filterTicketType,
    filterTaskSubject,
    filterTaskProgress,
    publicTasksDateMode,
    publicTasksPendingDateFilter,
    publicTasksDateFilter,
    myTasksOnly,

    filterSageAcc,
    filterDoorAcc,
    filterAccountType,
    filterBalance,

    filterApprovalSubject,
    filterApprovalType,

    trusteeSubTab,
    trusteeFilterName,
    trusteeFilterEmail,
    trusteeFilterMobile,
    trusteeCurrentPage,
  ]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    fetchWithToken(
      `https://portal.gmacc.co.za/api/building/${building_guid}/info/`,
      token,
    )
      .then((info) => {
        setAgeUpdatedToDate(info.cr446_ageupdatedtodate || "");
        if (info.cj_buildingname) {
          setBuildingName(info.cj_buildingname);
          // keep localStorage in sync if you need it elsewhere
          localStorage.setItem("buildingName", info.cj_buildingname);
          localStorage.setItem("BcId", info.cr446_bcbuildingid);
        }
      })
      .catch((err) => console.error("Could not fetch building name", err));
  }, [building_guid]);

  // Reset certain state values when switching tabs
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
    if (tab !== "Credit Control") setCreditSubTab("AOD");
    if (tab !== "General") {
      setDocFilterName("");
      setDocFilterDesignation("");
      setDocCurrentPage(1);
    }
    if (tab !== "Maintenance") setMaintSubTab("Active Maintenances");
  };

  const activePrimaryTab = dashboardTabs.includes(activeTab)
    ? "Dashboards"
    : otherTabs.includes(activeTab)
      ? "Other"
      : activeTab;

  const handlePrimaryTabChange = (tab) => {
    if (tab === "Landing") {
      handleTabChange("Landing");
      return;
    }

    if (tab === "Dashboards") {
      if (!dashboardTabs.includes(activeTab)) {
        handleTabChange(dashboardTabs[0]);
      }
      return;
    }

    if (tab === "Other") {
      if (!otherTabs.includes(activeTab)) {
        handleTabChange(otherTabs[0]);
      }
      return;
    }

    handleTabChange(tab);
  };

  const handleLandlordPortalClick = () => {
    localStorage.setItem("rental_portal_mode", "landlord");
    navigate("/rental-portal");
  };

  const handleTenantPortalClick = () => {
    localStorage.setItem("rental_portal_mode", "tenant");
    navigate("/rental-portal");
  };
  // Fetch building info and documents for the "General" tab
  const fetchGeneralInfo = async (token) => {
    const endpoint = `https://portal.gmacc.co.za/api/building/${building_guid}/info/`;
    const result = await fetchWithToken(endpoint, token);
    setData(result);
    if (result?.cj_buildingname) {
      setBuildingName(result.cj_buildingname);
      localStorage.setItem("buildingName", result.cj_buildingname);
    }
  };

  const fetchGeneralDocs = async (token) => {
    const endpoint = `https://portal.gmacc.co.za/api/building/${building_guid}/docs/`;
    try {
      const result = await fetchWithToken(endpoint, token);
      setDocuments(result.value || result);
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  };

  // Fetch trustees data from multiple endpoints concurrently.
  const fetchTrusteesData = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    if (!token) {
      alert("No token found. Please log in.");
      navigate("/");
      return;
    }
    try {
      const endpoints = [
        `https://portal.gmacc.co.za/api/building/${building_guid}/all-trustees/`,
        `https://portal.gmacc.co.za/api/building/${building_guid}/payment-trustees/`,
        `https://portal.gmacc.co.za/api/building/${building_guid}/maintenance-trustees/`,
        `https://portal.gmacc.co.za/api/building/${building_guid}/finance-trustees/`,
        `https://portal.gmacc.co.za/api/building/${building_guid}/credit-control-trustees/`,
        `https://portal.gmacc.co.za/api/building/${building_guid}/comms-conduct-trustees/`,
        `https://portal.gmacc.co.za/api/building/${building_guid}/garden-trustees/`,
        `https://portal.gmacc.co.za/api/building/${building_guid}/security-trustees/`,
      ];
      const responses = await Promise.all(
        endpoints.map((ep) => fetchWithToken(ep, token)),
      );
      setTrusteesData({
        all: responses[0],
        payment: responses[1],
        maintenance: responses[2],
        finance: responses[3],
        creditControl: responses[4],
        commsConduct: responses[5],
        garden: responses[6],
        security: responses[7],
      });
    } catch (e) {
      console.error("Error fetching trustees data", e);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data based on the active tab
  const fetchData = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    if (!token) {
      alert("No token found. Please log in.");
      navigate("/");
      return;
    }
    try {
      if (activeTab === "Landing") {
        await Promise.all([
          fetchLanding(token),
          fetchDebtorsDashboard(token),
          fetchMaintenanceDashboard(token),
        ]);
      } else if (activeTab === "General") {
        await fetchGeneralInfo(token);
        fetchGeneralDocs(token);
      } else if (activeTab === "Approvals") {
        const sub =
          approvalSubTab === "Active" ? "approvals" : "approvals-history";
        const endpoint = `https://portal.gmacc.co.za/api/building/${building_guid}/${sub}/`;
        const result = await fetchWithToken(endpoint, token);
        const normalized = Array.isArray(result) ? result : result.value || [];
        setData(normalized);
        localStorage.setItem(
          "trustee_building_approvals",
          JSON.stringify(normalized),
        );
      } else if (activeTab === "Payments") {
        const endpoint = `https://portal.gmacc.co.za/api/building/${building_guid}/payments/`;
        const result = await fetchWithToken(endpoint, token);
        setData(result);
        localStorage.setItem(
          "trustee_payments",
          JSON.stringify(result.value || result),
        );
      } else if (activeTab === "Debtors Dashboard") {
        await fetchDebtorsDashboard(token);
      } else if (activeTab === "Credit Control") {
        const sub = creditSubTab.toLowerCase().replace(/\s+/g, "");
        const endpoint = `https://portal.gmacc.co.za/api/building/${building_guid}/${sub}/`;
        const result = await fetchWithToken(endpoint, token);
        setData(result);
        if (sub === "aod") {
          localStorage.setItem(
            "trustee_aods",
            JSON.stringify(result.value || result),
          );
        } else if (sub === "legal") {
          localStorage.setItem(
            "trustee_legals",
            JSON.stringify(result.value || result),
          );
        } else if (sub === "disconnections") {
          localStorage.setItem(
            "trustee_disconnections",
            JSON.stringify(result.value || result),
          );
        } else if (sub === "balances") {
          localStorage.setItem(
            "trustee_balances",
            JSON.stringify(result.value || result),
          );
        }
        if (result?.cj_buildingname) setBuildingName(result.cj_buildingname);
      } else if (activeTab === "Tasks") {
        const endpoint = `https://portal.gmacc.co.za/api/building/${building_guid}/tasks/`;
        const result = await fetchWithToken(endpoint, token);
        setData(result);
        localStorage.setItem(
          "trustee_public_tasks",
          JSON.stringify(result.value || result),
        );
      } else if (activeTab === "Trustees") {
        fetchTrusteesData();
      } else if (activeTab === "Finance") {
        const endpoint = `https://portal.gmacc.co.za/api/building/${building_guid}/bankaccounts/`;
        const result = await fetchWithToken(endpoint, token);

        // keep existing behavior
        setData(result);
        localStorage.setItem(
          "trustee_bank_accounts",
          JSON.stringify(result.value || result),
        );

        // NEW: resolve bankAccountNumber -> BC account.netChange (backend now does bankAccounts accounts)
        try {
          const bcCompanyId = localStorage.getItem("BcId"); // must be set elsewhere
          if (!bcCompanyId) {
            console.warn(
              "[BC] Missing localStorage 'BcId'; skipping BC enrichment.",
            );
            return;
          }

          // Use today's local date (YYYY-MM-DD)
          const todayISODate = new Date().toISOString().split("T")[0];

          const list = Array.isArray(result?.value)
            ? result.value
            : Array.isArray(result)
              ? result
              : [];

          const bcCache = new Map();
          const bcDebug = [];

          // Calls your backend which now: bankAccounts(bankAccountNumber) -> accounts(number) -> netChange
          const fetchBcByBankAccountNumber = async (bankAccNo) => {
            if (!bankAccNo) return null;
            const key = String(bankAccNo).trim();
            if (bcCache.has(key)) return bcCache.get(key);

            // keep localhost for dev
            const bcUrl = `https://portal.gmacc.co.za/api/bc/accounts/by-number/${bcCompanyId}/${encodeURIComponent(
              key,
            )}/`;

            const resp = await fetchWithToken(bcUrl, token);

            bcDebug.push({
              bankAccountNumber: key,
              url: bcUrl,
              response: resp,
            });
            bcCache.set(key, resp);
            return resp;
          };

          const enriched = await Promise.all(
            list.map(async (item) => {
              const bankAccNo = item?.cj_accountnumber; // Dataverse bank account number shown in the grid
              let netChangeFromBc;

              try {
                const bcResp = await fetchBcByBankAccountNumber(bankAccNo);
                const match = bcResp?.value?.[0];
                const rawNet = match?.netChange;
                const parsed =
                  typeof rawNet === "number"
                    ? rawNet
                    : rawNet != null
                      ? Number(rawNet)
                      : NaN;
                if (Number.isFinite(parsed)) netChangeFromBc = parsed;
              } catch (e) {
                console.warn(
                  "[BC] netChange fetch failed for bankAccountNumber",
                  bankAccNo,
                  e,
                );
              }

              // Overwrite Last Recon Balance with BC netChange; set Last Recon Date to TODAY
              if (Number.isFinite(netChangeFromBc)) {
                return {
                  ...item,
                  cj_lastreconbalance: netChangeFromBc,
                  cj_lastrecondate: todayISODate,
                };
              }

              // Even if BC call fails, still stamp today's date (balance remains as-is)
              return { ...item, cj_lastrecondate: todayISODate };
            }),
          );

          const updated = { ...(result || {}), value: enriched };
          updated.__bcDebug = bcDebug; // keep your debug bundle
          setData(updated);
          localStorage.setItem(
            "trustee_bank_accounts",
            JSON.stringify(updated.value || updated),
          );
        } catch (e) {
          console.warn("BC augmentation failed:", e);
        }
      } else if (activeTab === "Maintenance Dashboard") {
        await fetchMaintenanceDashboard(token);
      } else if (activeTab === "Maintenance") {
        if (maintSubTab === "Active Maintenances") {
          const endpoint = `https://portal.gmacc.co.za/api/building/${building_guid}/maintenances/`;
          const result = await fetchWithToken(endpoint, token);
          setMaintData(result.value || result);
          localStorage.setItem(
            "trustee_maintenances",
            JSON.stringify(result.value || result),
          );
        } else if (maintSubTab === "History") {
          const endpoint = `https://portal.gmacc.co.za/api/building/${building_guid}/maintenances/inactive/`;
          const result = await fetchWithToken(endpoint, token);
          setMaintData(result.value || result);
          localStorage.setItem(
            "trustee_maintenance_history",
            JSON.stringify(result.value || result),
          );
        } else {
          const endpoint = `https://portal.gmacc.co.za/api/building/${building_guid}/maintenances2/`;
          const result = await fetchWithToken(endpoint, token);
          const withQuotes = await Promise.all(
            (result.value || result).map(async (rec) => {
              const q = await fetchWithToken(
                `https://portal.gmacc.co.za/api/maintenance/${rec.cj_maintenancebid}/quotes/`,
                token,
              );
              rec.quotes = q.value || q;
              return rec;
            }),
          );
          setMaintData(withQuotes);
          localStorage.setItem(
            "trustee_maintenances",
            JSON.stringify(withQuotes),
          );
        }
      } else {
        const tabPath = activeTab.toLowerCase().replace(/\s/g, "");
        const endpoint = `https://portal.gmacc.co.za/api/building/${building_guid}/${tabPath}/`;
        const result = await fetchWithToken(endpoint, token);
        setData(result);
        if (result?.cj_buildingname) setBuildingName(result.cj_buildingname);
      }
    } catch (e) {
      console.error("Error fetching data for tab", activeTab, e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab !== "General") {
      setCurrentPage(1);
      setDocCurrentPage(1);
    }

    fetchData();
  }, [
    activeTab,
    creditSubTab,
    maintSubTab,
    approvalSubTab,
    building_guid,
    dashboardFinancialYear,
  ]);

  useEffect(() => {
    document.title = buildingName
      ? `GMA Portal || ${buildingName} Info`
      : "GMA Portal || Building Info";
  }, [buildingName]);

  // Fetch trustee contact details when trusteesData changes
  useEffect(() => {
    if (trusteesData) {
      const token = localStorage.getItem("token");
      const toFetch = [];
      Object.values(trusteesData).forEach((g) =>
        g.value?.forEach((t) => t.contactid && toFetch.push(t.contactid)),
      );
      const unique = Array.from(new Set(toFetch)).filter(
        (id) => !trusteeDetails[id],
      );
      if (unique.length) {
        Promise.allSettled(
          unique.map((id) =>
            fetchWithToken(
              `https://portal.gmacc.co.za/api/contact/${id}/`,
              token,
            ).then((d) => ({ id, d })),
          ),
        ).then((res) => {
          const newD = {};
          res.forEach((r) => {
            if (r.status === "fulfilled") newD[r.value.id] = r.value.d;
          });
          setTrusteeDetails((td) => ({ ...td, ...newD }));
        });
      }
    }
  }, [trusteesData]);

  if (!accessChecked) {
    return (
      <div className={styles.page}>
        <div className={styles.shell}>
          <main className={styles.contentArea}>
            <div className={styles.panel}>
              <div className={styles.loadingContainer}>
                <div className={styles.loadingImage}></div>
                <p className={styles.loadingText}>Checking Access...</p>
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }

  if (!hasAccess) return null;
  // Render table content based on active tab
  const renderTable = () => {
    if (loading) {
      return (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingImage}></div>
          <p className={styles.loadingText}>Loading...</p>
        </div>
      );
    }
    if (activeTab === "Landing") {
      const { tasks } = landingData;

      const {
        unitBalances,
        totalDebt,
        arrearsUnits,
        handedOverAccountCount,
        activeAodCount,
        activeDisconnected,
      } = getDebtorsDashboardSummary(debtorsDashboardData);

      const { allActiveJobs, totalInvoice, overdueJobs, awaitingQuotes } =
        getMaintenanceDashboardSummary(maintenanceDashboardData);

      const currentContactId = String(contactId || "").toLowerCase();

      const myOutstandingTasks = tasks
        .filter((item) => {
          const progress = getFormatted(item, "cj_progresss");
          const assignedContactId = String(
            item._cj_assignedtowhom_value || "",
          ).toLowerCase();

          return (
            currentContactId &&
            assignedContactId === currentContactId &&
            progress !== "Completed" &&
            progress !== "Canceled"
          );
        })
        .sort(
          (a, b) =>
            new Date(b.createdon || 0).getTime() -
            new Date(a.createdon || 0).getTime(),
        );

      const taskPreview = myOutstandingTasks.slice(0, 5);

      return (
        <div className={styles.landing}>
          <section className={styles.landingHero}>
            <p className={styles.landingEyebrow}>Building Overview</p>
            <h2>{buildingName || "Building"} at a glance</h2>
            <p>
              Outstanding work and the most important debtor and maintenance
              indicators.
            </p>
          </section>

          <section
            className={styles.landingKpiGrid}
            aria-label="Important building information"
          >
            <div className={styles.landingKpiCard}>
              <span>Total Debt</span>
              <strong>{money(totalDebt)}</strong>
              <small>{unitBalances.length} units</small>
            </div>
            <div className={styles.landingKpiCard}>
              <span>Arrear Accounts</span>
              <strong>{arrearsUnits.length}</strong>
              <small>Combined debt 30 days and older</small>
            </div>
            <div className={styles.landingKpiCard}>
              <span>My Tasks</span>
              <strong>{myOutstandingTasks.length}</strong>
              <small>Outstanding public tasks</small>
            </div>
            <div
              className={`${styles.landingKpiCard} ${
                overdueJobs.length ? styles.landingKpiAlert : ""
              }`}
            >
              <span>Overdue Maintenance</span>
              <strong>{overdueJobs.length}</strong>
              <small>{allActiveJobs.length} active jobs</small>
            </div>
          </section>

          <div className={styles.landingContentGrid}>
            <section className={styles.landingPanel}>
              <div className={styles.landingPanelHeader}>
                <div>
                  <span>Action List</span>
                  <h3>My outstanding tasks</h3>
                </div>
                <button
                  type="button"
                  className={styles.landingTextButton}
                  onClick={() => {
                    setMyTasksOnly(true);
                    handleTabChange("Tasks");
                  }}
                >
                  View all tasks
                </button>
              </div>

              {taskPreview.length ? (
                <div className={styles.landingTaskList}>
                  {taskPreview.map((item) => {
                    const progress =
                      getFormatted(item, "cj_progresss") || "New";
                    return (
                      <button
                        type="button"
                        className={styles.landingTaskItem}
                        key={item.cj_publictasksid}
                        onClick={() =>
                          navigate(
                            `/task/${item.cj_publictasksid}/${building_guid}`,
                          )
                        }
                      >
                        <span className={styles.landingTaskMain}>
                          <strong>{item.cj_subjectt || "Untitled task"}</strong>
                          <small>
                            {getFormatted(item, "cj_tickettype") ||
                              "Public task"}
                            {item.createdon
                              ? ` - ${formatDate(item.createdon, "dd MMM yyyy")}`
                              : ""}
                          </small>
                        </span>
                        <span className={styles.landingTaskStatus}>
                          {progress}
                        </span>
                      </button>
                    );
                  })}
                </div>
              ) : (
                <div className={styles.landingEmptyState}>
                  No outstanding tasks are assigned to you.
                </div>
              )}
            </section>

            <section className={styles.landingDashboardSection}>
              <div className={styles.landingSectionHeader}>
                <span>Dashboard snapshots</span>
                <h3>Building performance</h3>
              </div>

              <div className={styles.landingDashboardGrid}>
                <button
                  type="button"
                  className={styles.landingDashboardCard}
                  onClick={() => handleTabChange("Debtors Dashboard")}
                >
                  <span className={styles.landingDashboardLabel}>
                    Debtors Dashboard
                  </span>
                  <strong>{money(totalDebt)}</strong>
                  <small>Total outstanding debt</small>
                  <div className={styles.landingMetricRow}>
                    <span>
                      <b>{arrearsUnits.length}</b> units in arrears
                    </span>
                    <span>
                      <b>{handedOverAccountCount}</b> handed over
                    </span>
                    <span>
                      <b>{activeAodCount}</b> active AODs
                    </span>
                    <span>
                      <b>{activeDisconnected.length}</b> disconnected
                    </span>
                  </div>
                  <span className={styles.landingOpenLabel}>
                    Open dashboard
                  </span>
                </button>

                <button
                  type="button"
                  className={styles.landingDashboardCard}
                  onClick={() => handleTabChange("Maintenance Dashboard")}
                >
                  <span className={styles.landingDashboardLabel}>
                    Maintenance Dashboard
                  </span>

                  <strong>{allActiveJobs.length}</strong>
                  <small>Active maintenance jobs</small>

                  <div className={styles.landingMetricRow}>
                    <span>
                      <b>{overdueJobs.length}</b> overdue
                    </span>
                    <span>
                      <b>{awaitingQuotes.length}</b> awaiting quotes
                    </span>
                    <span>
                      <b>{money(totalInvoice)}</b> invoiced
                    </span>
                  </div>

                  <span className={styles.landingOpenLabel}>
                    Open dashboard
                  </span>
                </button>
              </div>
            </section>
          </div>
        </div>
      );
    } else if (activeTab === "General") {
      if (!data)
        return (
          <div className={styles.errorText}>
            <p>No building info found.</p>
          </div>
        );

      const filteredDocs = documents.filter((doc) => {
        const nameMatch =
          !docFilterName ||
          doc.cj_name.toLowerCase().includes(docFilterName.toLowerCase());
        const designation =
          doc[
            "cj_documentdesignation@OData.Community.Display.V1.FormattedValue"
          ] || "";
        const designationMatch =
          !docFilterDesignation || designation === docFilterDesignation;
        return nameMatch && designationMatch;
      });

      const totalDocRecords = filteredDocs.length;
      const paginatedDocs = filteredDocs.slice(
        (docCurrentPage - 1) * docRecordsPerPage,
        (docCurrentPage - 1) * docRecordsPerPage + docRecordsPerPage,
      );

      return (
        <>
          {/* MAIN 2-COLUMN LAYOUT */}
          <div className={styles.generalTwoColumnLayout}>
            {/* ================= LEFT SIDE â€” GENERAL INFO ================= */}
            <div className={styles.generalLeftColumn}>
              <div className={styles.generalFieldRow}>
                <div className={styles.generalFieldLabel}>Building Name:</div>
                <div className={styles.generalFieldValue}>
                  {data.cj_buildingname}
                </div>
              </div>

              <div className={styles.generalFieldRow}>
                <div className={styles.generalFieldLabel}>Caretaker:</div>
                <div className={styles.generalFieldValue}>
                  {
                    data[
                      "_cj_caretaker_value@OData.Community.Display.V1.FormattedValue"
                    ]
                  }
                </div>
              </div>

              <div className={styles.generalFieldRow}>
                <div className={styles.generalFieldLabel}>
                  Number of Trustees:
                </div>
                <div className={styles.generalFieldValue}>
                  {data[
                    "ab_numberoftrustees@OData.Community.Display.V1.FormattedValue"
                  ] || data.ab_numberoftrustees}
                </div>
              </div>

              <div className={styles.generalFieldRow}>
                <div className={styles.generalFieldLabel}>
                  Insurance Broker:
                </div>

                <div
                  className={`${styles.generalFieldValue} ${styles.generalClickable}`}
                  onClick={() =>
                    navigate(
                      `/contractor/${data._cj_insurancebrokercontractor_value}/${building_guid}`,
                    )
                  }
                >
                  {
                    data[
                      "_cj_insurancebrokercontractor_value@OData.Community.Display.V1.FormattedValue"
                    ]
                  }{" "}
                  || Mobile:{" "}
                  {data.cj_InsuranceBrokerContractor?.cj_companytelephone} ||
                  Email: {data.cj_InsuranceBrokerContractor?.emailaddress}
                </div>
              </div>

              <div className={styles.generalFieldRow}>
                <div className={styles.generalFieldLabel}>Insurer:</div>

                <div
                  className={`${styles.generalFieldValue} ${styles.generalClickable}`}
                  onClick={() =>
                    navigate(
                      `/contractor/${data._cj_insurercontractor_value}/${building_guid}`,
                    )
                  }
                >
                  {
                    data[
                      "_cj_insurercontractor_value@OData.Community.Display.V1.FormattedValue"
                    ]
                  }
                </div>
              </div>

              <div className={styles.generalFieldRow}>
                <div className={styles.generalFieldLabel}>
                  Insurance Evaluation Date:
                </div>
                <div className={styles.generalFieldValue}>
                  {formatDate(data.ab_insurancenext3years)}
                </div>
              </div>

              <div className={styles.generalFieldRow}>
                <div className={styles.generalFieldLabel}>
                  Registration Number:
                </div>
                <div className={styles.generalFieldValue}>
                  {data.cj_registrationnumber}
                </div>
              </div>

              <div className={styles.generalFieldRow}>
                <div className={styles.generalFieldLabel}>CSOS Reg Number:</div>
                <div className={styles.generalFieldValue}>
                  {data.ab_csosregnumber}
                </div>
              </div>
            </div>

            {/* ================= RIGHT SIDE â€” DOCUMENTS PANEL ================= */}
            <div className={styles.generalDocsPanel}>
              <div className={styles.generalDocsFilterRow}>
                <input
                  type="text"
                  placeholder="Filter Document Name"
                  value={docFilterName}
                  onChange={(e) => {
                    setDocFilterName(e.target.value);
                    setDocCurrentPage(1);
                  }}
                  className={styles.generalDocsSearchInput}
                />

                <select
                  value={docFilterDesignation}
                  onChange={(e) => {
                    setDocFilterDesignation(e.target.value);
                    setDocCurrentPage(1);
                  }}
                  className={styles.generalDocsSelect}
                >
                  <option value="">All Designations</option>
                  {[
                    "Audit",
                    "Bank Confirmation",
                    "Budget",
                    "Complex Policy",
                    "Conduct Rules",
                    "Credit Policy",
                    "Insurance Policy",
                    "Minutes",
                    "Newsletter",
                    "Other",
                    "SS Plan",
                  ].map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>

                <button
                  className={styles.generalDocsClearBtn}
                  onClick={() => {
                    setDocFilterName("");
                    setDocFilterDesignation("");
                    setDocCurrentPage(1);
                  }}
                >
                  Clear Filters
                </button>
              </div>

              {filteredDocs.length > 0 ? (
                <>
                  <div className={styles.generalDocsTableWrapper}>
                    <table className={styles.generalDocsTable}>
                      <thead>
                        <tr>
                          <th>Document Name</th>
                          <th>Designation</th>
                          <th>Download</th>
                        </tr>
                      </thead>

                      <tbody>
                        {paginatedDocs.map((doc) => (
                          <tr key={doc.cj_documentid}>
                            <td>{doc.cj_name}</td>
                            <td>
                              {
                                doc[
                                  "cj_documentdesignation@OData.Community.Display.V1.FormattedValue"
                                ]
                              }
                            </td>
                            <td>
                              <a
                                href={`https://portal.gmacc.co.za/api/building/document/${doc.cj_documentid}/download/`}
                                download={doc.cj_content_name}
                                className={styles.viewFileBtn}
                              >
                                Download
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className={styles.pagination}>
                    <button
                      className={`${styles.pageBtn} ${styles.pageBtnPrimary}`}
                      disabled={docCurrentPage === 1}
                      onClick={() => setDocCurrentPage(docCurrentPage - 1)}
                    >
                      Previous
                    </button>

                    <span className={styles.pageMeta}>
                      {totalDocRecords === 0
                        ? "0â€“0 of 0"
                        : `${
                            (docCurrentPage - 1) * docRecordsPerPage + 1
                          }â€“${Math.min(
                            docCurrentPage * docRecordsPerPage,
                            totalDocRecords,
                          )} of ${totalDocRecords}`}
                    </span>

                    <button
                      className={`${styles.pageBtn} ${styles.pageBtnPrimary}`}
                      disabled={
                        docCurrentPage * docRecordsPerPage >= totalDocRecords
                      }
                      onClick={() => setDocCurrentPage(docCurrentPage + 1)}
                    >
                      Next
                    </button>
                  </div>
                </>
              ) : (
                <div className={styles.errorText}>
                  <p>No documents found.</p>
                </div>
              )}
            </div>
          </div>
        </>
      );
    } else if (activeTab === "Payments") {
      if (!data || !data.value) {
        return (
          <div className={styles.errorText}>
            <p>No payment details found.</p>
          </div>
        );
      }

      const filtered = data.value.filter((item) => {
        const matchesPaymentPk =
          !filterPaymentPk ||
          item.cr446_paymentpk
            ?.toLowerCase()
            .includes(filterPaymentPk.toLowerCase());
        const matchesOurRef =
          !filterOurReference ||
          item.cr446_ourreference
            ?.toLowerCase()
            .includes(filterOurReference.toLowerCase());
        const paymentType =
          item["cr446_paymenttype@OData.Community.Display.V1.FormattedValue"];
        const matchesType =
          !filterPaymentType ||
          item[
            "cr446_paymenttype@OData.Community.Display.V1.FormattedValue"
          ] === filterPaymentType;
        const paidTo =
          paymentType === "Account"
            ? item[
                "_cj_accountt_value@OData.Community.Display.V1.FormattedValue"
              ]
            : paymentType === "Municipality"
              ? item[
                  "_cj_municipality_value@OData.Community.Display.V1.FormattedValue"
                ]
              : item[
                  "_cr446_contractorname_value@OData.Community.Display.V1.FormattedValue"
                ];
        const matchesPaidTo =
          !filterPaidTo ||
          paidTo?.toLowerCase().includes(filterPaidTo.toLowerCase());
        const matchesProg =
          !filterProgress ||
          item["cj_progress@OData.Community.Display.V1.FormattedValue"] ===
            filterProgress;
        return (
          matchesPaymentPk &&
          matchesOurRef &&
          matchesPaidTo &&
          matchesType &&
          matchesProg
        );
      });

      const sorted = filtered.sort((a, b) => {
        const keyA = String(b.cr446_paymentpk || "");
        const keyB = String(a.cr446_paymentpk || "");
        return keyA.localeCompare(keyB);
      });
      const total = sorted.length;
      const paginated = sorted.slice(
        (currentPage - 1) * recordsPerPage,
        (currentPage - 1) * recordsPerPage + recordsPerPage,
      );

      return (
        <div>
          <div className={styles.filterRow}>
            <input
              type="text"
              placeholder="Payment Number"
              value={filterPaymentPk}
              onChange={(e) => {
                setFilterPaymentPk(e.target.value);
                setCurrentPage(1);
              }}
              className={styles.searchInput}
            />
            <input
              type="text"
              placeholder="Our Reference"
              value={filterOurReference}
              onChange={(e) => {
                setFilterOurReference(e.target.value);
                setCurrentPage(1);
              }}
              className={styles.searchInput}
            />
            <input
              type="text"
              placeholder="Paid To"
              value={filterPaidTo}
              onChange={(e) => {
                setFilterPaidTo(e.target.value);
                setCurrentPage(1);
              }}
              className={styles.searchInput}
            />
            <select
              value={filterPaymentType}
              onChange={(e) => {
                setFilterPaymentType(e.target.value);
                setCurrentPage(1);
              }}
              className={styles.select}
            >
              <option value="">All Payment Types</option>
              {[
                "Account",
                "Contractor",
                "Legal",
                "Maintenance",
                "Municipality",
                "Recurring",
              ].map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
            <select
              value={filterProgress}
              onChange={(e) => {
                setFilterProgress(e.target.value);
                setCurrentPage(1);
              }}
              className={styles.select}
            >
              <option value="">All Progress</option>
              {[
                "Approval Declined",
                "Canceled",
                "Delayed",
                "Delayed - Cashflow restriction",
                "Loaded for confirmation",
                "Loaded for payment",
                "New",
                "On Hold",
                "Paid",
                "Ready for payment",
                "Waiting for Bank Authorization",
                "Waiting for FICA",
                "Waiting for Trustee Approval",
              ].map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
            <button
              className={styles.docClearBtn}
              onClick={() => {
                setFilterPaymentPk("");
                setFilterOurReference("");
                setFilterPaymentType("");
                setFilterProgress("");
                setCurrentPage(1);
              }}
            >
              Clear Filters
            </button>
          </div>

          <div className={styles.maintp}>
            <p>For most buildings the municipal payments will not be shown.</p>
          </div>
          <div className={styles.responsiveTableWrapper}>
            <table className={styles.dataTable}>
              <thead>
                <tr>
                  <th>Payment Number</th>
                  <th>Amount</th>
                  <th>Payment Type</th>
                  <th>Paid To</th>
                  <th>Our Reference</th>
                  <th>Progress</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {paginated.map((item) => {
                  const paymentType =
                    item[
                      "cr446_paymenttype@OData.Community.Display.V1.FormattedValue"
                    ];
                  const paidTo =
                    paymentType === "Account"
                      ? item[
                          "_cj_accountt_value@OData.Community.Display.V1.FormattedValue"
                        ]
                      : paymentType === "Municipality"
                        ? item[
                            "_cj_municipality_value@OData.Community.Display.V1.FormattedValue"
                          ]
                        : item[
                            "_cr446_contractorname_value@OData.Community.Display.V1.FormattedValue"
                          ];

                  const progress =
                    item[
                      "cj_progress@OData.Community.Display.V1.FormattedValue"
                    ];
                  const displayDate =
                    progress === "Paid"
                      ? formatDate(item.cj_paymenttime)
                      : formatDate(item.createdon);
                  const dateLabel =
                    progress === "Paid" ? "Payment Date:" : "Created Date:";

                  return (
                    <tr key={item.cr446_paymentid}>
                      <td
                        onClick={() =>
                          navigate(
                            `/payment/${item.cr446_paymentid}/${building_guid}`,
                          )
                        }
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.textDecoration = "underline")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.textDecoration = "none")
                        }
                        style={{ cursor: "pointer", textDecoration: "none" }}
                      >
                        {item.cr446_paymentpk}
                      </td>
                      <td>
                        <span className={styles.amountCell}>
                          {formatAmount(item.cr446_amount)}
                        </span>
                      </td>
                      <td>{paymentType}</td>
                      <td
                        onClick={() => {
                          if (paymentType === "Account") {
                            // trustee account view
                            navigate(
                              `/trustee-account/${item._cj_accountt_value}/${building_guid}`,
                            );
                          } else if (item._cr446_contractorname_value) {
                            // contractor view
                            navigate(
                              `/contractor/${item._cr446_contractorname_value}/${building_guid}`,
                            );
                          }
                        }}
                        onMouseEnter={(e) => {
                          if (
                            (paymentType === "Account" &&
                              item._cj_accountt_value) ||
                            (paymentType !== "Account" &&
                              item._cr446_contractorname_value)
                          ) {
                            e.currentTarget.style.textDecoration = "underline";
                          }
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.textDecoration = "none";
                        }}
                        style={{
                          cursor:
                            (paymentType === "Account" &&
                              item._cj_accountt_value) ||
                            (paymentType !== "Account" &&
                              item._cr446_contractorname_value)
                              ? "pointer"
                              : "default",
                        }}
                      >
                        {paidTo}
                      </td>
                      <td>{item.cr446_ourreference}</td>
                      <td
                        className={
                          progress === "Paid" ? styles.paidProgress : ""
                        }
                      >
                        {progress}
                      </td>
                      <td>
                        {dateLabel} {displayDate}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalRecords={total}
            recordsPerPage={recordsPerPage}
          />
        </div>
      );
    } else if (activeTab === "Approvals") {
      // show sub-tabs first
      return (
        <>
          {/* APPROVAL SUB-TABS */}
          <SubTabSelector
            tabs={["Active", "History"]}
            activeTab={approvalSubTab}
            onSelect={(t) => {
              setApprovalSubTab(t);
              setCurrentPage(1);
            }}
          />

          {/* EXISTING APPROVAL CONTENT â€” UNCHANGED */}
          {(() => {
            if (!data || data.length === 0)
              return (
                <div className={styles.errorText}>
                  <p>No building approvals found.</p>
                </div>
              );

            let approvals = Array.isArray(data) ? data : data?.value || [];
            approvals = approvals
              .filter((item) => {
                const subject = item.subject?.toLowerCase() || "";
                const type =
                  item[
                    "cj_approvaltype@OData.Community.Display.V1.FormattedValue"
                  ] || "";

                const matchesSubject =
                  !filterApprovalSubject ||
                  subject.includes(filterApprovalSubject.toLowerCase());
                const matchesType =
                  !filterApprovalType || type === filterApprovalType;

                return matchesSubject && matchesType;
              })
              .sort((a, b) => new Date(b.createdon) - new Date(a.createdon));

            const total = approvals.length;
            const paginated = approvals.slice(
              (currentPage - 1) * approvalsPerPage,
              (currentPage - 1) * approvalsPerPage + approvalsPerPage,
            );

            return (
              <div>
                <div className={styles.filterRow}>
                  <input
                    type="text"
                    placeholder="Filter Subject"
                    value={filterApprovalSubject}
                    onChange={(e) => {
                      setFilterApprovalSubject(e.target.value);
                      setCurrentPage(1);
                    }}
                    className={styles.searchInput}
                  />

                  <select
                    value={filterApprovalType}
                    onChange={(e) => {
                      setFilterApprovalType(e.target.value);
                      setCurrentPage(1);
                    }}
                    className={styles.select}
                  >
                    <option value="">All Types</option>
                    {approvalTypeOptions.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>

                  <button
                    className={styles.docClearBtn}
                    onClick={() => {
                      setFilterApprovalSubject("");
                      setFilterApprovalType("");
                      setCurrentPage(1);
                    }}
                  >
                    Clear Filters
                  </button>
                </div>

                <div className={styles.maintp}>
                  <p>
                    Below is the list of all current building approvals, that
                    are still awaiting approval from trustees.
                  </p>
                </div>

                <div className={styles.responsiveTableWrapper}>
                  <table className={styles.dataTable}>
                    <thead>
                      <tr>
                        <th>Subject</th>
                        <th>Status</th>
                        <th>Type</th>
                        <th>Linked Item</th>
                        <th>Required Approvals</th>
                        <th>Approval Count</th>
                        <th>Created On</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginated.map((item) => (
                        <tr key={item.activityid}>
                          <td
                            className={`${styles.text} ${styles.approvalsSubjectCell}`}
                            title={item.subject}
                            onClick={() =>
                              navigate(`/building-approvals/${item.activityid}`)
                            }
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.textDecoration =
                                "underline")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.textDecoration = "none")
                            }
                            style={{
                              cursor: "pointer",
                              textDecoration: "none",
                            }}
                          >
                            {item.subject}
                          </td>

                          <td>
                            {
                              item[
                                "cj_approvalstatus@OData.Community.Display.V1.FormattedValue"
                              ]
                            }
                          </td>
                          <td>
                            {
                              item[
                                "cj_approvaltype@OData.Community.Display.V1.FormattedValue"
                              ]
                            }
                          </td>

                          <td
                            onClick={() => {
                              const type =
                                item[
                                  "cj_approvaltype@OData.Community.Display.V1.FormattedValue"
                                ];
                              let id, path;

                              if (
                                type === "Maintenance work approval" ||
                                type === "Maintenance Quote Selection"
                              ) {
                                id = item["_cj_linkedmaintenancejob_value"];
                                path = "maintenance";
                              } else if (type === "Payment") {
                                id = item["_cj_linkedpayment_value"];
                                path = "payment";
                              } else if (type === "AOD") {
                                id = item["_cj_linkedaodrecord_value"];
                                path = "aod";
                              } else if (type === "Conduct Letter") {
                                id = item["_cj_linkedconductletter_value"];
                                path = "conduct";
                              }

                              if (id)
                                navigate(`/${path}/${id}/${building_guid}`);
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.textDecoration =
                                "underline")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.textDecoration = "none")
                            }
                            style={{
                              cursor: [
                                "Maintenance work approval",
                                "Maintenance Quote Selection",
                                "Payment",
                                "AOD",
                              ].includes(
                                item[
                                  "cj_approvaltype@OData.Community.Display.V1.FormattedValue"
                                ],
                              )
                                ? "pointer"
                                : "default",
                            }}
                          >
                            {(() => {
                              const type =
                                item[
                                  "cj_approvaltype@OData.Community.Display.V1.FormattedValue"
                                ];
                              if (
                                type === "Maintenance work approval" ||
                                type === "Maintenance Quote Selection"
                              )
                                return item[
                                  "_cj_linkedmaintenancejob_value@OData.Community.Display.V1.FormattedValue"
                                ];

                              if (type === "Payment")
                                return item[
                                  "_cj_linkedpayment_value@OData.Community.Display.V1.FormattedValue"
                                ];

                              if (type === "AOD")
                                return item[
                                  "_cj_linkedaodrecord_value@OData.Community.Display.V1.FormattedValue"
                                ];

                              return "-";
                            })()}
                          </td>

                          <td>{item.cj_requiredapprovalcount}</td>
                          <td>{item.cj_approvalcount}</td>
                          <td>{formatDate(item.createdon)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalRecords={total}
                  recordsPerPage={approvalsPerPage}
                />
              </div>
            );
          })()}
        </>
      );
    } else if (activeTab === "Debtors Dashboard") {
      const { balances, statistics, correlation } = debtorsDashboardData;

      const {
        unitBalances,
        totalDebt,
        currentDebt,
        age30,
        age60,
        age90,
        age120,
        arrearsUnits,
        legalDebt,
        handedOverAccountCount,
        activeAodCount,
        aodTarget,
        aodReceipts,
        aodShortfall,
        activeDisconnected,
      } = getDebtorsDashboardSummary(debtorsDashboardData);

      const getOverdueBalance = (item) =>
        Number(item.cj_age30days || 0) +
        Number(item.cj_age60days || 0) +
        Number(item.cj_age90days || 0) +
        Number(item.cj_age120days || 0) +
        Number(item.cj_age150days || 0) +
        Number(item.cj_age180days || 0);

      const topDebtorsByUnit = balances.reduce((units, account) => {
        // Top 10 only includes active accounts.
        if (Number(account?.statecode) !== 0) return units;

        const unitId =
          account?._cj_unitname_value || account?.cj_UnitName?.cj_gmaunitsid;

        if (!unitId) return units;

        const key = String(unitId).trim().toLowerCase();

        let unit = units.get(key);

        if (!unit) {
          unit = {
            unitId,
            unitName:
              account?.cj_UnitName?.cj_unitname ||
              account?.cj_doornumber ||
              "N/A",
            totalAge: 0,
            overdueBalance: 0,
            accountCount: 0,
            navigationAccountId: null,
          };

          units.set(key, unit);
        }

        const totalAge = Number(account?.cj_agetotal || 0);

        if (Number.isFinite(totalAge)) {
          unit.totalAge += totalAge;
        }

        unit.overdueBalance += getOverdueBalance(account);
        unit.accountCount += 1;

        const accountType = String(
          account?.[
            "ab_accounttype@OData.Community.Display.V1.FormattedValue"
          ] || "",
        )
          .trim()
          .toLowerCase();

        // Preserve click-through, preferring the Owner account.
        if (!unit.navigationAccountId || accountType === "owner") {
          unit.navigationAccountId =
            account?.cj_gmaaccountnumberid || unit.navigationAccountId;
        }

        return units;
      }, new Map());

      const topDebtors = [...topDebtorsByUnit.values()]
        // Preserve the existing rule: Top 10 must have debt 30+ days.
        .filter((unit) => unit.overdueBalance > 0 && unit.totalAge > 0)
        .sort((a, b) => b.totalAge - a.totalAge)
        .slice(0, 10);

      const maxDebtor = Math.max(...topDebtors.map((unit) => unit.totalAge), 1);

      const ageBuckets = [
        {
          label: "Current",
          value: currentDebt,
          color: DASHBOARD_PIE_COLOURS.coolGrey,
        },
        {
          label: "30 Days",
          value: age30,
          color: DASHBOARD_PIE_COLOURS.blueTint,
        },
        {
          label: "60 Days",
          value: age60,
          color: DASHBOARD_PIE_COLOURS.blue,
        },
        {
          label: "90 Days",
          value: age90,
          color: DASHBOARD_PIE_COLOURS.steel,
        },
        {
          label: "120+ Days",
          value: age120,
          color: DASHBOARD_PIE_COLOURS.cardinal,
        },
      ];

      const ageChartTotal = ageBuckets.reduce(
        (total, bucket) => total + Math.max(Number(bucket.value) || 0, 0),
        0,
      );

      let ageChartOffset = 0;

      const ageChartSegments = ageBuckets.map((bucket) => {
        const amount = Math.max(Number(bucket.value) || 0, 0);
        const start = ageChartOffset;
        const end =
          ageChartTotal > 0 ? start + (amount / ageChartTotal) * 100 : start;

        ageChartOffset = end;

        return `${bucket.color} ${start}% ${end}%`;
      });

      const ageChartBackground =
        ageChartTotal > 0
          ? `conic-gradient(${ageChartSegments.join(", ")})`
          : "#edf2f7";

      const prepareStatisticsChart = (slices = []) => {
        const visibleSlices = slices
          .map((slice, index) => ({
            ...slice,
            colour:
              DASHBOARD_STATISTICS_COLOURS[slice.label] ||
              DASHBOARD_PIE_SEQUENCE[index % DASHBOARD_PIE_SEQUENCE.length],
          }))
          .filter((slice) => Number(slice.count || 0) > 0);

        const total = visibleSlices.reduce(
          (sum, slice) => sum + Number(slice.count || 0),
          0,
        );

        let offset = 0;

        const segments = visibleSlices.map((slice) => {
          const start = offset;
          const end =
            total > 0
              ? start + (Number(slice.count || 0) / total) * 100
              : start;

          offset = end;

          return `${slice.colour} ${start}% ${end}%`;
        });

        return {
          slices: visibleSlices,
          background:
            total > 0 ? `conic-gradient(${segments.join(", ")})` : "#edf2f7",
        };
      };

      const aodStatisticsChart = prepareStatisticsChart(
        statistics?.aod?.slices,
      );

      const legalStatisticsChart = prepareStatisticsChart(
        statistics?.legal?.slices,
      );

      const ageChange = Number(statistics?.ageing?.change || 0);
      const correlationPoints = Array.isArray(correlation?.points)
        ? correlation.points.map((point) => ({
            ...point,
            debtors: Number(point.debtors || 0),
            bank_balance: Number(point.bank_balance || 0),
          }))
        : [];

      const latestCorrelation = correlationPoints[correlationPoints.length - 1];

      const correlationChart = (() => {
        const width = 980;
        const height = 320;
        const padding = {
          top: 24,
          right: 28,
          bottom: 48,
          left: 92,
        };

        const values = correlationPoints.flatMap((point) => [
          point.debtors,
          point.bank_balance,
        ]);

        const rawMinimum = Math.min(0, ...values);
        const rawMaximum = Math.max(0, ...values);

        const minimum = rawMinimum < 0 ? rawMinimum * 1.08 : 0;
        const maximum = rawMaximum > 0 ? rawMaximum * 1.08 : 1;

        const range = maximum - minimum || 1;
        const plotWidth = width - padding.left - padding.right;
        const plotHeight = height - padding.top - padding.bottom;

        const x = (index) =>
          padding.left +
          (index / Math.max(correlationPoints.length - 1, 1)) * plotWidth;

        const y = (value) =>
          padding.top + ((maximum - Number(value || 0)) / range) * plotHeight;

        const createPath = (field) =>
          correlationPoints
            .map(
              (point, index) =>
                `${index === 0 ? "M" : "L"} ${x(index)} ${y(point[field])}`,
            )
            .join(" ");

        return {
          width,
          height,
          padding,
          minimum,
          maximum,
          x,
          y,
          debtorsPath: createPath("debtors"),
          bankPath: createPath("bank_balance"),
          yTicks: Array.from({ length: 5 }, (_, index) => {
            const value = maximum - (range * index) / 4;

            return {
              value,
              y: y(value),
            };
          }),
        };
      })();

      return (
        <div className={styles.debtDash}>
          <div className={styles.debtHero}>
            <div>
              <p className={styles.debtEyebrow}>Credit Control Snapshot</p>
              <h2>{buildingName || "Building"} Debtors Dashboard</h2>
              <p>
                A visual summary of balances, arrears, legal files, arrangements
                and disconnections for this building.
              </p>
            </div>
            <div className={styles.dashboardFinancialYearControl}>
              <label htmlFor="debtors-dashboard-financial-year">
                Financial Year
              </label>

              <select
                id="debtors-dashboard-financial-year"
                value={dashboardFinancialYear}
                onChange={(e) => setDashboardFinancialYear(e.target.value)}
              >
                <option value="current">Current Financial Year</option>
                <option value="previous">Previous Financial Year</option>
              </select>

              <small>
                {statistics?.financial_year?.label || "Loading period..."}
              </small>
            </div>
          </div>

          <div className={styles.debtCorrelationPanel}>
            <div className={styles.debtCorrelationHeader}>
              <div>
                <h3>Debtors Owed vs Bank Balances</h3>
                <p>Month-end balances for the selected financial year.</p>
              </div>

              <span>
                {correlation?.as_of
                  ? `12 months to ${formatDate(
                      correlation.as_of,
                      "dd MMM yyyy",
                    )}`
                  : "Last 12 months"}
              </span>
            </div>

            {correlationPoints.length === 0 ? (
              <div className={styles.emptyDashboardState}>
                {correlation?.error ||
                  "Debtors and bank balance history is unavailable."}
              </div>
            ) : (
              <>
                <div className={styles.debtCorrelationLegend}>
                  <div className={styles.debtCorrelationLegendItem}>
                    <i
                      className={`${styles.debtCorrelationKey} ${styles.debtCorrelationDebtorsKey}`}
                    />
                    <span>Debtors · GL 6001101</span>
                    <strong>{money(latestCorrelation?.debtors)}</strong>
                  </div>

                  <div className={styles.debtCorrelationLegendItem}>
                    <i
                      className={`${styles.debtCorrelationKey} ${styles.debtCorrelationBankKey}`}
                    />
                    <span>
                      Bank balances · {correlation?.bank_account_count || 0}{" "}
                      accounts
                    </span>
                    <strong>{money(latestCorrelation?.bank_balance)}</strong>
                  </div>
                </div>

                <div className={styles.debtCorrelationChartScroll}>
                  <svg
                    className={styles.debtCorrelationSvg}
                    viewBox={`0 0 ${correlationChart.width} ${correlationChart.height}`}
                    role="img"
                    aria-label="Line graph comparing debtors owed with total bank balances for the last twelve months"
                  >
                    <title>Debtors owed compared with bank balances</title>

                    {correlationChart.yTicks.map((tick, index) => (
                      <g key={index}>
                        <line
                          className={styles.debtCorrelationGridLine}
                          x1={correlationChart.padding.left}
                          x2={
                            correlationChart.width -
                            correlationChart.padding.right
                          }
                          y1={tick.y}
                          y2={tick.y}
                        />
                        <text
                          className={styles.debtCorrelationAxisText}
                          x={correlationChart.padding.left - 12}
                          y={tick.y}
                          textAnchor="end"
                          dominantBaseline="middle"
                        >
                          {compactMoney(tick.value)}
                        </text>
                      </g>
                    ))}

                    {correlationChart.minimum < 0 &&
                      correlationChart.maximum > 0 && (
                        <line
                          className={styles.debtCorrelationZeroLine}
                          x1={correlationChart.padding.left}
                          x2={
                            correlationChart.width -
                            correlationChart.padding.right
                          }
                          y1={correlationChart.y(0)}
                          y2={correlationChart.y(0)}
                        />
                      )}

                    {correlationPoints.map((point, index) => (
                      <text
                        className={styles.debtCorrelationAxisText}
                        key={point.date}
                        x={correlationChart.x(index)}
                        y={
                          correlationChart.height -
                          correlationChart.padding.bottom +
                          25
                        }
                        textAnchor="middle"
                      >
                        {point.label}
                      </text>
                    ))}

                    <path
                      className={styles.debtCorrelationDebtorsLine}
                      d={correlationChart.debtorsPath}
                      fill="none"
                    />

                    <path
                      className={styles.debtCorrelationBankLine}
                      d={correlationChart.bankPath}
                      fill="none"
                    />

                    {correlationPoints.map((point, index) => (
                      <React.Fragment key={point.date}>
                        <circle
                          className={styles.debtCorrelationDebtorsPoint}
                          cx={correlationChart.x(index)}
                          cy={correlationChart.y(point.debtors)}
                          r="4"
                        >
                          <title>
                            {`${point.label} debtors: ${money(point.debtors)}`}
                          </title>
                        </circle>

                        <circle
                          className={styles.debtCorrelationBankPoint}
                          cx={correlationChart.x(index)}
                          cy={correlationChart.y(point.bank_balance)}
                          r="4"
                        >
                          <title>
                            {`${point.label} bank balances: ${money(
                              point.bank_balance,
                            )}`}
                          </title>
                        </circle>
                      </React.Fragment>
                    ))}
                  </svg>
                </div>
              </>
            )}
          </div>

          <div className={styles.debtKpiGrid}>
            <div className={styles.debtKpiCard}>
              <span>Total Debt</span>
              <strong>{money(totalDebt)}</strong>
              <small>{unitBalances.length} units</small>
            </div>

            <div className={styles.debtKpiCard}>
              <span>Arrears Accounts</span>
              <strong>{arrearsUnits.length}</strong>
              <small>Combined debt 30 days and older</small>
            </div>

            <div className={styles.debtKpiCard}>
              <span>Accounts Handed Over</span>
              <strong>{handedOverAccountCount}</strong>
              <small>{money(legalDebt)} handed over</small>
            </div>

            <div className={styles.debtKpiCard}>
              <span>Active AODs</span>
              <strong>{activeAodCount}</strong>
              <small>{money(aodReceipts)} received</small>
            </div>

            <div className={styles.debtKpiCard}>
              <span>Disconnected</span>
              <strong>{activeDisconnected.length}</strong>
              <small>active service blocks</small>
            </div>
          </div>

          <div className={styles.debtGridTwo}>
            <div className={styles.debtPanel}>
              <div className={styles.debtPanelHeader}>
                <div className={styles.debtPanelHeaderTitle}>
                  <h3>Age Analysis</h3>
                  <small>
                    {ageUpdatedToDate
                      ? `Ages updated to ${formatDate(
                          ageUpdatedToDate,
                          "dd MMM yyyy",
                        )}`
                      : "Age update date unavailable"}
                  </small>
                </div>

                <span>{money(totalDebt)}</span>
              </div>

              <div className={styles.ageChart}>
                <div
                  className={styles.agePie}
                  style={{ background: ageChartBackground }}
                  role="img"
                  aria-label={`Age analysis: ${ageBuckets
                    .map((bucket) => `${bucket.label} ${money(bucket.value)}`)
                    .join(", ")}`}
                >
                  <div className={styles.agePieCenter}>
                    <strong></strong>
                    <span></span>
                  </div>
                </div>

                <div className={styles.ageLegend}>
                  {ageBuckets.map((bucket) => {
                    const chartValue = Math.max(Number(bucket.value) || 0, 0);
                    const percentage =
                      ageChartTotal > 0
                        ? (chartValue / ageChartTotal) * 100
                        : 0;

                    return (
                      <div className={styles.ageLegendItem} key={bucket.label}>
                        <span
                          className={styles.ageLegendColour}
                          style={{ backgroundColor: bucket.color }}
                        />

                        <div className={styles.ageLegendLabel}>
                          <strong>{bucket.label}</strong>
                          <small>{percentage.toFixed(1)}%</small>
                        </div>

                        <span className={styles.ageLegendValue}>
                          {money(bucket.value)}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className={styles.debtPanel}>
              <div className={styles.debtPanelHeader}>
                <h3>Debt Scenario Split</h3>
                <span>Live</span>
              </div>

              <div className={styles.scenarioGrid}>
                <div>
                  <strong>{money(legalDebt)}</strong>
                  <span>Total Legal Handed Over Amount</span>
                </div>
                <div>
                  <strong>{money(aodTarget)}</strong>
                  <span>
                    AOD Target – Total amount expected to have been received to
                    date from active AODs
                  </span>
                </div>
                <div>
                  <strong>{money(aodShortfall)}</strong>
                  <span>
                    AOD Shortfall – Amount expected but not yet received from
                    active AODs
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.debtGridTwo}>
            <div className={styles.debtPanel}>
              <div className={styles.debtPanelHeader}>
                <h3>Top 10 Debtors</h3>
                <span>
                  Highest unit balances with arrears 30 days and older
                </span>
              </div>

              <div className={styles.topDebtorList}>
                {topDebtors.length === 0 ? (
                  <div className={styles.emptyDashboardState}>
                    No debtors found.
                  </div>
                ) : (
                  topDebtors.map((item, index) => {
                    const amount = item.totalAge;
                    return (
                      <div
                        key={item.unitId || index}
                        className={styles.topDebtorItem}
                        onClick={() => {
                          if (item.navigationAccountId) {
                            navigate(
                              `/levyaccount/${item.navigationAccountId}/${building_guid}`,
                            );
                          }
                        }}
                      >
                        <div className={styles.topDebtorRank}>{index + 1}</div>
                        <div className={styles.topDebtorMain}>
                          <strong>Unit {item.unitName}</strong>
                          <span>
                            {item.accountCount} active account
                            {item.accountCount === 1 ? "" : "s"}
                          </span>
                          <div className={styles.topDebtorBar}>
                            <div
                              style={{
                                width: `${Math.max(5, (amount / maxDebtor) * 100)}%`,
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className={styles.topDebtorAmount}>
                          {money(amount)}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>

            <div className={styles.debtPanel}>
              <div className={`${styles.debtPanel} ${styles.statisticsPanel}`}>
                <div className={styles.debtPanelHeader}>
                  <h3>Statistics</h3>
                  <span>
                    {statistics?.financial_year?.label ||
                      "Current financial year"}
                  </span>
                </div>

                {!statistics?.financial_year ? (
                  <div className={styles.emptyDashboardState}>
                    Statistics are unavailable.
                  </div>
                ) : (
                  <>
                    <div className={styles.statisticsSummary}>
                      <div className={styles.statisticsMetric}>
                        <span>Opening Total Age</span>
                        <strong>
                          {money(statistics.ageing?.opening?.amount)}
                        </strong>
                        <small>
                          GL 6001101 ·{" "}
                          {formatDate(
                            statistics.ageing?.opening?.date,
                            "dd MMM yyyy",
                          )}
                        </small>
                      </div>

                      <div className={styles.statisticsMetric}>
                        <span>
                          {dashboardFinancialYear === "previous"
                            ? "Closing Total Age"
                            : "Total Age Today"}
                        </span>
                        <strong>
                          {money(statistics.ageing?.current?.amount)}
                        </strong>
                        <small>
                          GL 6001101 ·{" "}
                          {formatDate(
                            statistics.ageing?.current?.date,
                            "dd MMM yyyy",
                          )}
                        </small>
                      </div>

                      <div className={styles.statisticsMetric}>
                        <span>Age Movement</span>
                        <strong>{money(Math.abs(ageChange))}</strong>
                        <small>
                          {ageChange >= 0 ? "Increase" : "Decrease"}
                          {statistics.ageing?.change_percentage !== null &&
                            ` · ${Math.abs(
                              statistics.ageing.change_percentage,
                            ).toFixed(1)}%`}
                        </small>
                      </div>

                      <div className={styles.statisticsMetric}>
                        <span>Legal Fees Paid</span>
                        <strong>{money(statistics.legal?.fees_paid)}</strong>
                        <small>
                          {statistics.financial_year.start} to{" "}
                          {statistics.financial_year.reporting_end}
                        </small>
                      </div>

                      <div className={styles.statisticsMetric}>
                        <span>Judgements Received</span>
                        <strong>
                          {statistics.legal?.judgements_received || 0}
                        </strong>
                        <small>Unique main accounts · active legal files</small>
                      </div>
                    </div>

                    <div className={styles.statisticsCharts}>
                      <div className={styles.statisticsChartCard}>
                        <div className={styles.statisticsChartHeader}>
                          <strong>AOD Statistics</strong>
                          <span>
                            {statistics.aod?.new_signed || 0} signed the FY
                          </span>
                        </div>

                        <div className={styles.statisticsPieLayout}>
                          <div
                            className={styles.statisticsPie}
                            style={{
                              background: aodStatisticsChart.background,
                            }}
                            role="img"
                            aria-label={aodStatisticsChart.slices
                              .map(
                                (slice) =>
                                  `${slice.label}: ${slice.percentage}%`,
                              )
                              .join(", ")}
                          >
                            <div className={styles.statisticsPieCenter}>
                              <strong>{statistics.aod?.total || 0}</strong>
                              <span>AODs</span>
                            </div>
                          </div>

                          <div className={styles.statisticsLegend}>
                            {aodStatisticsChart.slices.map((slice) => (
                              <div
                                className={styles.statisticsLegendItem}
                                key={slice.label}
                              >
                                <span
                                  className={styles.statisticsSwatch}
                                  style={{ backgroundColor: slice.colour }}
                                />

                                <div>
                                  <strong>{slice.label}</strong>
                                  <span>
                                    {slice.count} ·{" "}
                                    {Number(slice.percentage || 0).toFixed(1)}%
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className={styles.statisticsChartCard}>
                        <div className={styles.statisticsChartHeader}>
                          <strong>Legal File Statistics</strong>
                          <span>
                            {statistics.legal?.created_this_fy || 0} created ·{" "}
                            {statistics.legal?.closed_this_fy || 0} closed this
                            FY
                          </span>
                        </div>

                        <div className={styles.statisticsPieLayout}>
                          <div
                            className={styles.statisticsPie}
                            style={{
                              background: legalStatisticsChart.background,
                            }}
                            role="img"
                            aria-label={legalStatisticsChart.slices
                              .map(
                                (slice) =>
                                  `${slice.label}: ${slice.percentage}%`,
                              )
                              .join(", ")}
                          >
                            <div className={styles.statisticsPieCenter}>
                              <strong>
                                {statistics.legal?.active_total || 0}
                              </strong>
                              <span>Active</span>
                            </div>
                          </div>

                          <div className={styles.statisticsLegend}>
                            {legalStatisticsChart.slices.map((slice) => (
                              <div
                                className={styles.statisticsLegendItem}
                                key={slice.label}
                              >
                                <span
                                  className={styles.statisticsSwatch}
                                  style={{ backgroundColor: slice.colour }}
                                />

                                <div>
                                  <strong>{slice.label}</strong>
                                  <span>
                                    {slice.count} ·{" "}
                                    {Number(slice.percentage || 0).toFixed(1)}%
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    } else if (activeTab === "Credit Control") {
      return (
        <>
          {/* SHOW SUB-TABS */}
          <SubTabSelector
            tabs={creditSubTabs}
            activeTab={creditSubTab}
            onSelect={(t) => {
              setCreditSubTab(t);
              setCurrentPage(1);
            }}
          />

          {/* EXISTING CREDIT CONTROL LOGIC BELOW â€” UNCHANGED */}
          {(() => {
            if (!data || !data.value)
              return (
                <div className={styles.errorText}>
                  <p>No credit control details found.</p>
                </div>
              );
            if (creditSubTab === "AOD") {
              const total = data.value.length;
              const paginated = data.value.slice(
                (currentPage - 1) * recordsPerPage,
                (currentPage - 1) * recordsPerPage + recordsPerPage,
              );
              return (
                <div className={styles.page}>
                  <div className={styles.responsiveTableWrapper}>
                    <table className={styles.dataTable}>
                      <thead>
                        <tr>
                          <th>AOD Number</th>
                          <th>Linked Account</th>
                          <th>Full Name</th>
                          <th>Current Term</th>
                          <th>Total Term</th>
                          <th>Total Receipts</th>
                          <th>Total Target</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginated.map((item) => {
                          const totalReceipts = Number(
                            item.cj_totalreceiptssincedateofsignature,
                          );
                          const totalTarget = Number(
                            item.cj_totalrequiredreceiptssincesignature,
                          );
                          return (
                            <tr key={item.cj_aodid}>
                              <td
                                onClick={() =>
                                  navigate(
                                    `/aod/${item.cj_aodid}/${building_guid}`,
                                  )
                                }
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.textDecoration =
                                    "underline")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.textDecoration =
                                    "none")
                                }
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "none",
                                }}
                              >
                                {item.cj_aodnumber}
                              </td>
                              <td
                                onClick={() =>
                                  navigate(
                                    `/levyaccount/${item._cj_linkedaccount_value}/${building_guid}`,
                                  )
                                }
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.textDecoration =
                                    "underline")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.textDecoration =
                                    "none")
                                }
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "none",
                                }}
                              >
                                {
                                  item[
                                    "_cj_linkedaccount_value@OData.Community.Display.V1.FormattedValue"
                                  ]
                                }
                              </td>
                              <td>{item.cj_fullname}</td>
                              <td>{item.cj_currentagreementterm}</td>
                              <td>{item.cj_paymentterminmonths}</td>
                              <td
                                className={
                                  totalReceipts < totalTarget
                                    ? styles.lowReceipts
                                    : ""
                                }
                              >
                                <span className={styles.amountCell}>
                                  {formatAmount(
                                    item.cj_totalreceiptssincedateofsignature,
                                  )}
                                </span>
                              </td>
                              <td>
                                <span className={styles.amountCell}>
                                  {formatAmount(
                                    item.cj_totalrequiredreceiptssincesignature,
                                  )}
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalRecords={total}
                    recordsPerPage={recordsPerPage}
                  />
                </div>
              );
            } else if (creditSubTab === "Legal") {
              const total = data.value.length;
              const paginated = data.value.slice(
                (currentPage - 1) * recordsPerPage,
                (currentPage - 1) * recordsPerPage + recordsPerPage,
              );
              return (
                <div className={styles.page}>
                  <div className={styles.responsiveTableWrapper}>
                    <table className={styles.dataTable}>
                      <thead>
                        <tr>
                          <th>Account Number</th>
                          <th>Attorney</th>
                          <th>Progress</th>
                          <th>Type</th>
                          <th>Debt On Handover</th>
                          <th>Current Situation</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          // make a shallow copy, sort Aâ€“Z, then map
                          [...paginated]
                            .sort((a, b) =>
                              String(a.cr446_textaccountnumber).localeCompare(
                                String(b.cr446_textaccountnumber),
                                undefined,
                                { numeric: true },
                              ),
                            )
                            .map((item) => (
                              <tr key={item.cj_legalid}>
                                <td
                                  onClick={() =>
                                    navigate(
                                      `/legal/${item.cj_legalid}/${building_guid}`,
                                    )
                                  }
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.textDecoration =
                                      "underline")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.textDecoration =
                                      "none")
                                  }
                                  style={{
                                    cursor: "pointer",
                                    textDecoration: "none",
                                  }}
                                >
                                  {
                                    item[
                                      "_cj_account_value@OData.Community.Display.V1.FormattedValue"
                                    ]
                                  }
                                </td>
                                <td
                                  onClick={() =>
                                    navigate(
                                      `/contractor/${item._cj_attorney_value}/${building_guid}`,
                                    )
                                  }
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.textDecoration =
                                      "underline")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.textDecoration =
                                      "none")
                                  }
                                  style={{
                                    cursor: "pointer",
                                    textDecoration: "none",
                                  }}
                                >
                                  {
                                    item[
                                      "_cj_attorney_value@OData.Community.Display.V1.FormattedValue"
                                    ]
                                  }
                                </td>
                                <td>
                                  {
                                    item[
                                      "cj_progress@OData.Community.Display.V1.FormattedValue"
                                    ]
                                  }
                                </td>
                                <td>
                                  {
                                    item[
                                      "cr446_legaltype@OData.Community.Display.V1.FormattedValue"
                                    ]
                                  }
                                </td>
                                <td>
                                  <span className={styles.amountCell}>
                                    {formatAmount(item.cj_debtonhandover)}
                                  </span>
                                </td>
                                <td>{item.cj_currentsituationdescription}</td>
                              </tr>
                            ))
                        }
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalRecords={total}
                    recordsPerPage={recordsPerPage}
                  />
                </div>
              );
            } else if (creditSubTab === "Disconnections") {
              const filtered = data.value.filter((item) => {
                const door = item.cj_Accountnumber?.cj_doornumber
                  ? String(item.cj_Accountnumber.cj_doornumber)
                  : "";
                const doorMatch =
                  !filterDoorNumber ||
                  door.toLowerCase().includes(filterDoorNumber.toLowerCase());
                const status =
                  item["cj_status@OData.Community.Display.V1.FormattedValue"] ||
                  "";
                const statusMatch =
                  !filterDisconnectionStatus ||
                  status === filterDisconnectionStatus;
                const itemDate = formatDate(
                  item.cj_dateofinstruction,
                  "yyyy-MM-dd",
                );
                const dateMatch = !disconnectionDateFilter.from
                  ? true
                  : disconnectionDateMode === "single"
                    ? itemDate === disconnectionDateFilter.from
                    : itemDate >= disconnectionDateFilter.from &&
                      itemDate <= disconnectionDateFilter.to;
                return doorMatch && statusMatch && dateMatch;
              });
              const total = filtered.length;
              const paginated = filtered.slice(
                (currentPage - 1) * recordsPerPage,
                (currentPage - 1) * recordsPerPage + recordsPerPage,
              );
              return (
                <div>
                  <div className={styles.filterRow}>
                    <input
                      type="text"
                      placeholder="Filter Door Number"
                      value={filterDoorNumber}
                      onChange={(e) => {
                        setFilterDoorNumber(e.target.value);
                        setCurrentPage(1);
                      }}
                      className={styles.searchInput}
                    />
                    <select
                      value={filterDisconnectionStatus}
                      onChange={(e) => {
                        setFilterDisconnectionStatus(e.target.value);
                        setCurrentPage(1);
                      }}
                      className={styles.select}
                    >
                      <option value="">All Status</option>
                      {["Reconnected", "Disconnected"].map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                    <select
                      value={disconnectionDateMode}
                      onChange={(e) => {
                        setDisconnectionDateMode(e.target.value);
                        setDisconnectionPendingDateFilter({ from: "", to: "" });
                      }}
                      className={styles.select}
                    >
                      <option value="single">Single Date</option>
                      <option value="range">Date Range</option>
                    </select>
                    <div className={styles.dateFilterWrapper}>
                      <input
                        type="date"
                        value={disconnectionPendingDateFilter.from}
                        onChange={(e) => {
                          setDisconnectionPendingDateFilter({
                            ...disconnectionPendingDateFilter,
                            from: e.target.value,
                          });
                          setCurrentPage(1);
                        }}
                        className={styles.dateInput}
                      />
                      {disconnectionDateMode === "range" && (
                        <input
                          type="date"
                          value={disconnectionPendingDateFilter.to}
                          min={disconnectionPendingDateFilter.from}
                          onChange={(e) => {
                            setDisconnectionPendingDateFilter({
                              ...disconnectionPendingDateFilter,
                              to: e.target.value,
                            });
                            setCurrentPage(1);
                          }}
                          className={styles.dateInput}
                        />
                      )}
                    </div>
                    <button
                      className={styles.confirmBtn}
                      onClick={() => {
                        if (!disconnectionPendingDateFilter.from) return;
                        if (
                          disconnectionDateMode === "range" &&
                          !disconnectionPendingDateFilter.to
                        ) {
                          alert("Please select an end date.");
                          return;
                        }
                        setDisconnectionDateFilter({
                          ...disconnectionPendingDateFilter,
                        });
                      }}
                    >
                      Confirm Date
                    </button>
                    <button
                      className={styles.docClearBtn}
                      onClick={() => {
                        setFilterDoorNumber("");
                        setFilterDisconnectionStatus("");
                        setDisconnectionDateFilter({ from: "", to: "" });
                        setDisconnectionPendingDateFilter({ from: "", to: "" });
                        setCurrentPage(1);
                      }}
                    >
                      Clear Filters
                    </button>
                  </div>
                  <div className={styles.responsiveTableWrapper}>
                    <table className={styles.dataTable}>
                      <thead>
                        <tr>
                          <th>Account Number</th>
                          <th>Door Number</th>
                          <th>Status</th>
                          <th>Meter Reading On Disconnection</th>
                          <th>Date of Instruction</th>
                          <th>Instruction Sent To</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginated.map((item) => {
                          const status =
                            item[
                              "cj_status@OData.Community.Display.V1.FormattedValue"
                            ];
                          return (
                            <tr key={item.cj_disconnectionid}>
                              <td>
                                {
                                  item[
                                    "_cj_accountnumber_value@OData.Community.Display.V1.FormattedValue"
                                  ]
                                }
                              </td>
                              <td>{item.cj_Accountnumber?.cj_doornumber}</td>
                              <td>
                                <span
                                  className={
                                    status === "Reconnected"
                                      ? styles.reconnectedStatus
                                      : status === "Disconnected"
                                        ? styles.disconnectedStatus
                                        : ""
                                  }
                                >
                                  {status}
                                </span>
                              </td>
                              <td>{item.cj_meterreadingondisconnection}</td>
                              <td>{formatDate(item.cj_dateofinstruction)}</td>
                              <td>
                                {
                                  item[
                                    "_cj_disconnectioninstructionto_value@OData.Community.Display.V1.FormattedValue"
                                  ]
                                }
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalRecords={total}
                    recordsPerPage={recordsPerPage}
                  />
                </div>
              );
            } else if (creditSubTab === "Balances") {
              if (!data || !data.value)
                return (
                  <div className={styles.errorText}>
                    <p>No age account details found.</p>
                  </div>
                );
              let filteredAge = data.value;
              if (filterSageAcc)
                filteredAge = filteredAge.filter((item) =>
                  item.cj_sageaccountnumber
                    ?.toLowerCase()
                    .includes(filterSageAcc.toLowerCase()),
                );
              if (filterDoorAcc)
                filteredAge = filteredAge.filter((item) =>
                  item.cj_doornumber
                    ?.toLowerCase()
                    .includes(filterDoorAcc.toLowerCase()),
                );
              if (filterAccountType)
                filteredAge = filteredAge.filter(
                  (item) =>
                    item[
                      "ab_accounttype@OData.Community.Display.V1.FormattedValue"
                    ] === filterAccountType,
                );
              if (filterBalance === "Arrears")
                filteredAge = filteredAge.filter(
                  (item) => Number(item.cj_age30days) > 0,
                );
              else if (filterBalance === "Debit Only")
                filteredAge = filteredAge.filter(
                  (item) => Number(item.cj_agetotal) > 0,
                );
              else if (filterBalance === "Credit Only")
                filteredAge = filteredAge.filter(
                  (item) => Number(item.cj_agetotal) <= 0,
                );

              // 3. compute sums across filteredAge
              const sumTotal = filteredAge.reduce(
                (sum, i) => sum + Number(i.cj_agetotal),
                0,
              );
              const sumCurrent = filteredAge.reduce(
                (sum, i) => sum + Number(i.cj_agecurrent),
                0,
              );
              const sum30 = filteredAge.reduce(
                (sum, i) => sum + Number(i.cj_age30days),
                0,
              );
              const sum60 = filteredAge.reduce(
                (sum, i) => sum + Number(i.cj_age60days),
                0,
              );
              const sum90 = filteredAge.reduce(
                (sum, i) => sum + Number(i.cj_age90days),
                0,
              );
              const sum120 = filteredAge.reduce(
                (sum, i) => sum + Number(i.sum_age_120_180),
                0,
              );

              // 2. sort descending by total
              const sortedAge = filteredAge.sort(
                (a, b) => Number(b.cj_agetotal) - Number(a.cj_agetotal),
              );
              const total = sortedAge.length;
              const paginated = sortedAge.slice(
                (currentPage - 1) * recordsPerPage,
                (currentPage - 1) * recordsPerPage + recordsPerPage,
              );
              return (
                <div>
                  <div className={styles.filterRow}>
                    <input
                      type="text"
                      placeholder="Filter Account Number"
                      value={filterSageAcc}
                      onChange={(e) => {
                        setFilterSageAcc(e.target.value);
                        setCurrentPage(1);
                      }}
                      className={styles.searchInput}
                    />
                    <input
                      type="text"
                      placeholder="Filter Door Number"
                      value={filterDoorAcc}
                      onChange={(e) => {
                        setFilterDoorAcc(e.target.value);
                        setCurrentPage(1);
                      }}
                      className={styles.searchInput}
                    />
                    <select
                      value={filterAccountType}
                      onChange={(e) => {
                        setFilterAccountType(e.target.value);
                        setCurrentPage(1);
                      }}
                      className={styles.select}
                    >
                      <option value="">All Account Types</option>
                      {[
                        "Common Property Rental",
                        "Other",
                        "Owner",
                        "Tenant",
                        "Legal",
                      ].map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                    <select
                      value={filterBalance}
                      onChange={(e) => {
                        setFilterBalance(e.target.value);
                        setCurrentPage(1);
                      }}
                      className={styles.select}
                    >
                      <option value="">All Balances</option>
                      {["Arrears", "Debit Only", "Credit Only"].map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                    <button
                      className={styles.docClearBtn}
                      onClick={() => {
                        setFilterSageAcc("");
                        setFilterDoorAcc("");
                        setFilterAccountType("");
                        setFilterBalance("");
                        setCurrentPage(1);
                      }}
                    >
                      Clear Filters
                    </button>
                  </div>
                  <div className={styles.responsiveTableWrapper}>
                    <table className={styles.dataTable}>
                      <thead>
                        <tr>
                          <th>Account Number</th>
                          <th>Door Number</th>
                          <th>Age Total</th>
                          <th>Age Current</th>
                          <th>Age 30 Days</th>
                          <th>Age 60 Days</th>
                          <th>Age 90 Days</th>
                          <th>Age 120+ Days</th>
                          <th>Legal Balance</th>
                          <th>Account Type</th>
                        </tr>
                        {/* 3. sums row */}
                        <tr className={styles.sumRow}>
                          <td className={styles.total} colSpan={2}>
                            Totals:
                          </td>
                          <td>
                            {" "}
                            <span className={styles.sumRowamountCell}>
                              {formatAmount(sumTotal)}
                            </span>
                          </td>
                          <td>
                            {" "}
                            <span className={styles.sumRowamountCell}>
                              {formatAmount(sumCurrent)}
                            </span>
                          </td>
                          <td>
                            {" "}
                            <span className={styles.sumRowamountCell}>
                              {formatAmount(sum30)}
                            </span>
                          </td>
                          <td>
                            {" "}
                            <span className={styles.sumRowamountCell}>
                              {formatAmount(sum60)}
                            </span>
                          </td>
                          <td>
                            {" "}
                            <span className={styles.sumRowamountCell}>
                              {formatAmount(sum90)}
                            </span>
                          </td>
                          <td>
                            {" "}
                            <span className={styles.sumRowamountCell}>
                              {formatAmount(sum120)}
                            </span>
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                      </thead>
                      <tbody>
                        {paginated.map((item) => (
                          <tr
                            key={
                              item.cj_sageaccountnumber || item.cj_doornumber
                            }
                          >
                            <td
                              onClick={() =>
                                navigate(
                                  `/levyaccount/${item.cj_gmaaccountnumberid}/${building_guid}`,
                                )
                              }
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.textDecoration =
                                  "underline")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.textDecoration = "none")
                              }
                              style={{
                                cursor: "pointer",
                                textDecoration: "none",
                              }}
                            >
                              {item.cj_sageaccountnumber}
                            </td>
                            <td>{item.cj_doornumber}</td>
                            <td>
                              {" "}
                              <span className={styles.amountCell}>
                                {formatAmount(item.cj_agetotal)}
                              </span>
                            </td>
                            <td>
                              {" "}
                              <span className={styles.amountCell}>
                                {formatAmount(item.cj_agecurrent)}
                              </span>
                            </td>
                            <td>
                              {" "}
                              <span className={styles.amountCell}>
                                {formatAmount(item.cj_age30days)}
                              </span>
                            </td>
                            <td>
                              {" "}
                              <span className={styles.amountCell}>
                                {formatAmount(item.cj_age60days)}
                              </span>
                            </td>
                            <td>
                              {" "}
                              <span className={styles.amountCell}>
                                {formatAmount(item.cj_age90days)}
                              </span>
                            </td>
                            <td>
                              {" "}
                              <span className={styles.amountCell}>
                                {formatAmount(item.sum_age_120_180)}
                              </span>
                            </td>

                            <td>
                              {" "}
                              <span className={styles.amountCell}>
                                {formatAmount(
                                  item.cj_UnitName?.cr446_sumoflegalaccounts,
                                )}
                              </span>
                            </td>
                            <td>
                              {
                                item[
                                  "ab_accounttype@OData.Community.Display.V1.FormattedValue"
                                ]
                              }
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalRecords={total}
                    recordsPerPage={recordsPerPage}
                  />
                </div>
              );
            }
          })()}
        </>
      );
    } else if (activeTab === "Maintenance Dashboard") {
      const {
        active,
        history,
        glAccounts,
        majorCapitalAccounts,
        contractorPaidTotals,
        financialYear,
      } = maintenanceDashboardData;

      const getProgress = getMaintenanceProgress;

      const { allActiveJobs, totalInvoice, overdueJobs, awaitingQuotes } =
        getMaintenanceDashboardSummary(maintenanceDashboardData);

      const financialYearStart = financialYear?.start || "";
      const financialYearEnd = financialYear?.end || "";
      const financialYearLabel = financialYear?.label || "Not configured";

      const completedThisFinancialYear = history.filter((item) => {
        const completedDate = String(item.cj_dateofjobcompletion || "").slice(
          0,
          10,
        );

        return (
          completedDate &&
          financialYearStart &&
          completedDate >= financialYearStart &&
          completedDate <= financialYearEnd
        );
      });
      /* Active jobs only for the progress chart. */
      const jobsByProgress = allActiveJobs.reduce((acc, item) => {
        const progress = getProgress(item);
        acc[progress] = (acc[progress] || 0) + 1;
        return acc;
      }, {});

      const progressRows = Object.entries(jobsByProgress).sort(
        (a, b) => b[1] - a[1],
      );

      const progressTotal = progressRows.reduce(
        (total, [, count]) => total + count,
        0,
      );

      const progressColours = DASHBOARD_PIE_SEQUENCE;
      let progressCursor = 0;

      const progressSlices = progressRows.map(([label, count], index) => {
        const start = (progressCursor / progressTotal) * 360;
        progressCursor += count;
        const end = (progressCursor / progressTotal) * 360;

        return {
          label,
          count,
          start,
          end,
          percentage: Math.round((count / progressTotal) * 100),
          colour: progressColours[index % progressColours.length],
        };
      });

      const progressGradient =
        progressSlices.length > 0
          ? `conic-gradient(${progressSlices
              .map(
                (slice) => `${slice.colour} ${slice.start}deg ${slice.end}deg`,
              )
              .join(", ")})`
          : "#e2e8f0";

      const cleanGlDescription = (description) =>
        String(description || "")
          .replace(/^Rep\s+Maint\s*-\s*/i, "")
          .trim() || "Maintenance";

      const glAccountRows = [...glAccounts]
        .filter((item) => {
          const accountNo = Number(item.account_no);
          const amount = Number(item.amount);

          return (
            Number.isInteger(accountNo) &&
            accountNo >= 2001501 &&
            accountNo <= 2001598 &&
            Number.isFinite(amount) &&
            amount !== 0
          );
        })
        .sort((a, b) => Number(b.amount) - Number(a.amount));
      /*
       * Current active jobs plus jobs completed during the current
       * financial year.
       */
      const majorCapitalRows = [...majorCapitalAccounts]
        .filter((item) => {
          const accountNo = Number(item.account_no);
          const amount = Number(item.amount);

          return (
            Number.isInteger(accountNo) &&
            accountNo >= 2002100 &&
            accountNo <= 2002199 &&
            Number.isFinite(amount) &&
            amount !== 0
          );
        })
        .sort((a, b) => Number(b.amount) - Number(a.amount));

      const financialYearJobs =
        dashboardFinancialYear === "previous"
          ? completedThisFinancialYear
          : [...active, ...completedThisFinancialYear];

      const contractorStats = financialYearJobs.reduce((acc, item) => {
        const contractorName =
          item[
            "_cj_awardedtocontractor_value@OData.Community.Display.V1.FormattedValue"
          ] || "Unassigned";

        const contractorKey =
          item._cj_awardedtocontractor_value || contractorName;

        if (!acc.has(contractorKey)) {
          const contractorId = item._cj_awardedtocontractor_value || null;

          const paymentKey = String(contractorId || "").toLowerCase();

          acc.set(contractorKey, {
            id: contractorKey,
            contractorId,
            name: contractorName,
            jobs: 0,
            paid: Number(contractorPaidTotals?.[paymentKey] || 0),
          });
        }

        const contractor = acc.get(contractorKey);

        contractor.jobs += 1;

        return acc;
      }, new Map());

      const contractorRows = [...contractorStats.values()]
        .sort((a, b) => b.paid - a.paid || b.jobs - a.jobs)
        .slice(0, 8);

      return (
        <div className={styles.maintDash}>
          <div className={styles.maintHero}>
            <div>
              <p className={styles.maintEyebrow}>Maintenance Command Centre</p>
              <h2>{buildingName || "Building"} Maintenance Dashboard</h2>
              <p>
                A practical view of active jobs, overdue work, quote activity,
                contractor workload and maintenance spend.
              </p>
            </div>
            <div className={styles.dashboardFinancialYearControl}>
              <label htmlFor="maintenance-dashboard-financial-year">
                Financial Year
              </label>

              <select
                id="maintenance-dashboard-financial-year"
                value={dashboardFinancialYear}
                onChange={(e) => setDashboardFinancialYear(e.target.value)}
              >
                <option value="current">Current Financial Year</option>
                <option value="previous">Previous Financial Year</option>
              </select>

              <small>{financialYearLabel}</small>
            </div>
          </div>

          <div className={styles.maintKpiGrid}>
            <div className={styles.maintKpiCard}>
              <span>Active Jobs</span>
              <strong>{allActiveJobs.length}</strong>
              <small>currently open</small>
            </div>

            <div className={styles.maintKpiCard}>
              <span>Completed The FY</span>
              <strong>{completedThisFinancialYear.length}</strong>
              <small>{financialYearLabel}</small>
            </div>

            <div className={styles.maintKpiCard}>
              <span>Overdue Jobs</span>
              <strong>{overdueJobs.length}</strong>
              <small>needs follow-up</small>
            </div>

            <div className={styles.maintKpiCard}>
              <span>Awaiting Quotes</span>
              <strong>{awaitingQuotes.length}</strong>
              <small>no quotes loaded</small>
            </div>

            <div className={styles.maintKpiCard}>
              <span>Invoice Value</span>
              <strong>{money(totalInvoice)}</strong>
              <small>active jobs</small>
            </div>
          </div>

          <div className={styles.maintGridThree}>
            <div className={styles.maintPanel}>
              <div className={styles.maintPanelHeader}>
                <h3>Jobs by Progress</h3>
                <span>{allActiveJobs.length} active</span>
              </div>

              {progressSlices.length === 0 ? (
                <div className={styles.emptyDashboardState}>
                  No active maintenance jobs found.
                </div>
              ) : (
                <div className={styles.maintPieLayout}>
                  <div
                    className={styles.maintPieChart}
                    style={{ background: progressGradient }}
                    role="img"
                    aria-label={progressSlices
                      .map((slice) => `${slice.label}: ${slice.count}`)
                      .join(", ")}
                  ></div>

                  <div className={styles.maintPieLegend}>
                    {progressSlices.map((slice) => (
                      <div
                        className={styles.maintPieLegendItem}
                        key={slice.label}
                      >
                        <span
                          className={styles.maintPieSwatch}
                          style={{ backgroundColor: slice.colour }}
                        ></span>

                        <div>
                          <strong>{slice.label}</strong>
                          <span>
                            {slice.count} job(s) · {slice.percentage}%
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className={styles.maintPanel}>
              <div className={styles.maintPanelHeader}>
                <h3>General Maintenance Items</h3>
                <span>{financialYearLabel}</span>
              </div>

              <div className={styles.maintContractorList}>
                {glAccountRows.length === 0 ? (
                  <div className={styles.emptyDashboardState}>
                    No maintenance GL accounts found.
                  </div>
                ) : (
                  glAccountRows.map((item) => (
                    <div
                      className={styles.maintContractorItem}
                      key={item.account_no}
                    >
                      <div>
                        <strong>{cleanGlDescription(item.description)}</strong>
                        <span>{item.account_no}</span>
                      </div>

                      <b>{money(item.amount)}</b>
                    </div>
                  ))
                )}
              </div>
            </div>

            <div className={styles.maintPanel}>
              <div className={styles.maintPanelHeader}>
                <h3>Major Capital Items</h3>
                <span>{financialYearLabel}</span>
              </div>

              <div className={styles.maintContractorList}>
                {majorCapitalRows.length === 0 ? (
                  <div className={styles.emptyDashboardState}>
                    No major capital GL accounts found.
                  </div>
                ) : (
                  majorCapitalRows.map((item) => (
                    <div
                      className={styles.maintContractorItem}
                      key={item.account_no}
                    >
                      <div>
                        <strong>
                          {String(item.description || "")
                            .replace(/^MCI\s*-\s*/i, "")
                            .trim() || "Major Capital"}
                        </strong>
                        <span>{item.account_no}</span>
                      </div>

                      <b>{money(item.amount)}</b>
                    </div>
                  ))
                )}
              </div>
            </div>

            <div className={styles.maintPanel}>
              <div className={styles.maintPanelHeader}>
                <h3>Contractor Workload</h3>
                <span>{financialYearLabel}</span>
              </div>

              <div className={styles.maintContractorList}>
                {contractorRows.length === 0 ? (
                  <div className={styles.emptyDashboardState}>
                    No contractor workload found.
                  </div>
                ) : (
                  contractorRows.map((item) => (
                    <div className={styles.maintContractorItem} key={item.id}>
                      <div>
                        <strong
                          onClick={() => {
                            if (item.contractorId) {
                              navigate(
                                `/contractor/${item.contractorId}/${building_guid}`,
                              );
                            }
                          }}
                          onMouseEnter={(e) => {
                            if (item.contractorId) {
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.textDecoration = "none";
                          }}
                          style={{
                            cursor: item.contractorId ? "pointer" : "default",
                          }}
                        >
                          {item.name}
                        </strong>
                        <span>{item.jobs} job(s)</span>
                      </div>

                      <b>{money(item.paid)} paid</b>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      );
    } else if (activeTab === "Maintenance") {
      return (
        <>
          {/* MAINTENANCE SUB-TABS */}
          <SubTabSelector
            tabs={["Active Maintenances", "History", "Active Quotes"]}
            activeTab={maintSubTab}
            onSelect={(t) => {
              setMaintSubTab(t);
              setCurrentPage(1);
            }}
          />

          {/* EXISTING MAINTENANCE CODE â€” UNCHANGED, JUST WRAPPED */}
          {(() => {
            const total = maintData.length;
            const paginated = maintData.slice(
              (currentPage - 1) * recordsPerPage,
              (currentPage - 1) * recordsPerPage + recordsPerPage,
            );

            return (
              <div>
                {/* 1) ACTIVE MAINTENANCES */}
                {/* 2) HISTORY */}
                {/* 3) ACTIVE QUOTES */}
                {maintSubTab === "Active Maintenances" && (
                  <>
                    <div className={styles.maintp}>
                      <p>
                        Below is a comprehensive list of the current active
                        maintenance related records for the building, along with
                        the progress status of each record.
                      </p>
                    </div>

                    <div className={styles.responsiveTableWrapper}>
                      <table className={styles.dataTable}>
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Progress</th>
                            <th>Invoice Amount</th>
                            <th>Paid Amount</th>
                            <th>Awarded Contractor</th>
                            <th>Job Completion</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginated.map((item) => (
                            <tr key={item.cj_maintenancebid}>
                              <td
                                onClick={() =>
                                  navigate(
                                    `/maintenance/${item.cj_maintenancebid}/${building_guid}`,
                                  )
                                }
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.textDecoration =
                                    "underline")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.textDecoration =
                                    "none")
                                }
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "none",
                                }}
                              >
                                {item.cj_name}
                              </td>
                              <td>{item.cj_fulldescription}</td>
                              <td>
                                {
                                  item[
                                    "cj_progress@OData.Community.Display.V1.FormattedValue"
                                  ]
                                }
                              </td>
                              <td>
                                <span className={styles.amountCell}>
                                  {formatAmount(item.cj_invoiceamount)}
                                </span>
                              </td>
                              <td>
                                <span className={styles.amountCell}>
                                  {formatAmount(item.cj_sumofpayments)}
                                </span>
                              </td>
                              <td
                                onClick={() =>
                                  navigate(
                                    `/contractor/${item._cj_awardedtocontractor_value}/${building_guid}`,
                                  )
                                }
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.textDecoration =
                                    "underline")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.textDecoration =
                                    "none")
                                }
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "none",
                                }}
                              >
                                {
                                  item[
                                    "_cj_awardedtocontractor_value@OData.Community.Display.V1.FormattedValue"
                                  ]
                                }
                              </td>
                              <td>
                                {item.cj_dateofjobcompletion
                                  ? formatDate(item.cj_dateofjobcompletion)
                                  : "N/A"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}

                {/* 2) HISTORY */}
                {maintSubTab === "History" && (
                  <>
                    <div className={styles.maintp}>
                      <p>
                        Here is the full history of all completed maintenance
                        jobs, showing their final status and completion dates.
                      </p>
                    </div>

                    <div className={styles.responsiveTableWrapper}>
                      <table className={styles.dataTable}>
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Progress</th>
                            <th>Invoice Amount</th>
                            <th>Paid Amount</th>
                            <th>Awarded Contractor</th>
                            <th>Job Completion</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginated.map((item) => (
                            <tr key={item.cj_maintenancebid}>
                              <td
                                onClick={() =>
                                  navigate(
                                    `/maintenance/${item.cj_maintenancebid}/${building_guid}`,
                                  )
                                }
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.textDecoration =
                                    "underline")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.textDecoration =
                                    "none")
                                }
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "none",
                                }}
                              >
                                {item.cj_name}
                              </td>
                              <td>{item.cj_fulldescription}</td>
                              <td>
                                {
                                  item[
                                    "cj_progress@OData.Community.Display.V1.FormattedValue"
                                  ]
                                }
                              </td>
                              <td>
                                <span className={styles.amountCell}>
                                  {formatAmount(item.cj_invoiceamount)}
                                </span>
                              </td>
                              <td>
                                <span className={styles.amountCell}>
                                  {formatAmount(item.cj_sumofpayments)}
                                </span>
                              </td>
                              <td
                                onClick={() =>
                                  navigate(
                                    `/contractor/${item._cj_awardedtocontractor_value}/${building_guid}`,
                                  )
                                }
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.textDecoration =
                                    "underline")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.textDecoration =
                                    "none")
                                }
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "none",
                                }}
                              >
                                {
                                  item[
                                    "_cj_awardedtocontractor_value@OData.Community.Display.V1.FormattedValue"
                                  ]
                                }
                              </td>
                              <td>
                                {item.cj_dateofjobcompletion
                                  ? formatDate(item.cj_dateofjobcompletion)
                                  : "N/A"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}

                {/* 3) ACTIVE QUOTES */}
                {maintSubTab === "Active Quotes" && (
                  <>
                    <div className={styles.maintp}>
                      <p>
                        The following items are currently in the quotation
                        process, and we are awaiting formal quotations for your
                        approval. We are actively following up with contractors
                        every second day.
                      </p>
                    </div>

                    <div className={styles.responsiveTableWrapper}>
                      <table className={styles.dataTable}>
                        <thead>
                          <tr>
                            <th>Quotes For</th>
                            <th>Description</th>
                            <th>Progress</th>
                            <th>Quotes</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginated.map((item) => (
                            <tr key={item.cj_maintenancebid}>
                              <td
                                onClick={() =>
                                  navigate(
                                    `/maintenance/${item.cj_maintenancebid}/${building_guid}`,
                                  )
                                }
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.textDecoration =
                                    "underline")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.textDecoration =
                                    "none")
                                }
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "none",
                                }}
                              >
                                {item.cj_name}
                              </td>
                              <td>{item.cj_fulldescription}</td>
                              <td>
                                {
                                  item[
                                    "cj_progress@OData.Community.Display.V1.FormattedValue"
                                  ]
                                }
                              </td>
                              <td>
                                {item.quotes && item.quotes.length > 0 ? (
                                  <ul>
                                    {item.quotes.map((quote) => (
                                      <li key={quote.cj_quoteid}>
                                        {quote.cj_name} -{" "}
                                        {formatAmount(quote.cj_amount)}{" "}
                                        {quote.cj_quotelink && (
                                          <a
                                            href={quote.cj_quotelink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            View Quote
                                          </a>
                                        )}
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  "No quotes available"
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}

                {/* PAGINATION */}
                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalRecords={total}
                  recordsPerPage={recordsPerPage}
                />
              </div>
            );
          })()}
        </>
      );
    } else if (activeTab === "Tasks") {
      if (!data || !data.value)
        return (
          <div className={styles.errorText}>
            <p>No tasks found.</p>
          </div>
        );

      // 1. Default exclude Completed only if no progress filter is set
      let filtered = data.value.filter((item) => {
        const prog =
          item["cj_progresss@OData.Community.Display.V1.FormattedValue"] || "";
        return !filterTaskProgress ? prog !== "Completed" : true;
      });

      // 2. Apply all other filters (including progress if selected)
      filtered = filtered.filter((item) => {
        const ticketType =
          item["cj_tickettype@OData.Community.Display.V1.FormattedValue"] || "";
        const subject = item.cj_subjectt || "";
        const prog =
          item["cj_progresss@OData.Community.Display.V1.FormattedValue"] || "";
        const createdDate = formatDate(
          item["createdon@OData.Community.Display.V1.FormattedValue"],
        );

        // My Tasks toggle
        if (myTasksOnly && item._cj_assignedtowhom_value !== contactId) {
          return false;
        }

        const matchesType =
          !filterTicketType || ticketType === filterTicketType;
        const matchesSubj =
          !filterTaskSubject ||
          subject.toLowerCase().includes(filterTaskSubject.toLowerCase());
        const matchesProg = !filterTaskProgress || prog === filterTaskProgress;

        // Date filter
        let dateMatch = true;
        if (publicTasksDateFilter.from) {
          dateMatch =
            publicTasksDateMode === "single"
              ? createdDate === publicTasksDateFilter.from
              : createdDate >= publicTasksDateFilter.from &&
                createdDate <= publicTasksDateFilter.to;
        }

        return matchesType && matchesSubj && matchesProg && dateMatch;
      });

      const total = filtered.length;
      const paginated = filtered.slice(
        (currentPage - 1) * recordsPerPage,
        (currentPage - 1) * recordsPerPage + recordsPerPage,
      );

      return (
        <div>
          <div className={styles.filterRow}>
            <button
              className={`${styles.confirmBtn} ${
                myTasksOnly ? styles.activeMyTasksButton : ""
              }`}
              onClick={() => {
                setMyTasksOnly(!myTasksOnly);
                setCurrentPage(1);
              }}
            >
              {myTasksOnly ? "View ALL Tasks" : "View My Tasks"}
            </button>

            <select
              value={filterTicketType}
              onChange={(e) => {
                setFilterTicketType(e.target.value);
                setCurrentPage(1);
              }}
              className={styles.select}
            >
              <option value="">All Ticket Types</option>
              {[
                "AGM Task",
                "Board Meeting Task",
                "Conduct",
                "Financial",
                "Insurance",
                "Legal",
                "Maintenance",
                "Municipality",
                "Reports",
              ].map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>

            <input
              type="text"
              placeholder="Filter Subject"
              value={filterTaskSubject}
              onChange={(e) => {
                setFilterTaskSubject(e.target.value);
                setCurrentPage(1);
              }}
              className={styles.searchInput}
            />

            <select
              value={filterTaskProgress}
              onChange={(e) => {
                setFilterTaskProgress(e.target.value);
                setCurrentPage(1);
              }}
              className={styles.select}
            >
              <option value="">Not Completed</option>
              {["Canceled", "Completed", "In Progress", "New", "On hold"].map(
                (opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ),
              )}
            </select>

            <select
              value={publicTasksDateMode}
              onChange={(e) => {
                setPublicTasksDateMode(e.target.value);
                setPublicTasksPendingDateFilter({ from: "", to: "" });
              }}
              className={styles.select}
            >
              <option value="single">Single Date</option>
              <option value="range">Date Range</option>
            </select>

            <div className={styles.dateFilterWrapper}>
              <input
                type="date"
                value={publicTasksPendingDateFilter.from}
                onChange={(e) => {
                  setPublicTasksPendingDateFilter({
                    ...publicTasksPendingDateFilter,
                    from: e.target.value,
                  });
                  setCurrentPage(1);
                }}
                className={styles.dateInput}
              />
              {publicTasksDateMode === "range" && (
                <input
                  type="date"
                  value={publicTasksPendingDateFilter.to}
                  min={publicTasksPendingDateFilter.from}
                  onChange={(e) => {
                    setPublicTasksPendingDateFilter({
                      ...publicTasksPendingDateFilter,
                      to: e.target.value,
                    });
                    setCurrentPage(1);
                  }}
                  className={styles.dateInput}
                />
              )}
            </div>

            <button
              className={styles.confirmBtn}
              onClick={() => {
                if (!publicTasksPendingDateFilter.from) return;
                if (
                  publicTasksDateMode === "range" &&
                  !publicTasksPendingDateFilter.to
                ) {
                  alert("Please select an end date.");
                  return;
                }
                setPublicTasksDateFilter({
                  ...publicTasksPendingDateFilter,
                });
              }}
            >
              Confirm Date
            </button>

            <button
              className={styles.docClearBtn}
              onClick={() => {
                setFilterTicketType("");
                setFilterTaskSubject("");
                setFilterTaskProgress("");
                setPublicTasksDateFilter({ from: "", to: "" });
                setPublicTasksPendingDateFilter({ from: "", to: "" });
                setMyTasksOnly(false);
                setCurrentPage(1);
              }}
            >
              Clear Filters
            </button>
          </div>
          <div className={styles.responsiveTableWrapper}>
            <table className={styles.dataTable}>
              <thead>
                <tr>
                  <th>Ticket Type</th>
                  <th>Assigned To</th>
                  <th>Subject</th>
                  <th>Progress</th>
                  <th>Created Date</th>
                </tr>
              </thead>
              <tbody>
                {paginated.map((item) => {
                  const prog =
                    item[
                      "cj_progresss@OData.Community.Display.V1.FormattedValue"
                    ];
                  return (
                    <tr key={item.cj_publictasksid}>
                      <td
                        onClick={() =>
                          navigate(
                            `/task/${item.cj_publictasksid}/${building_guid}`,
                          )
                        }
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.textDecoration = "underline")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.textDecoration = "none")
                        }
                        style={{ cursor: "pointer", textDecoration: "none" }}
                      >
                        {
                          item[
                            "cj_tickettype@OData.Community.Display.V1.FormattedValue"
                          ]
                        }
                      </td>
                      <td>
                        {
                          item[
                            "_cj_assignedtowhom_value@OData.Community.Display.V1.FormattedValue"
                          ]
                        }
                      </td>
                      <td>{item.cj_subjectt}</td>
                      <td
                        className={
                          prog === "Completed" ? styles.completedTask : ""
                        }
                      >
                        {prog}
                      </td>
                      <td>
                        {formatDate(
                          item[
                            "createdon@OData.Community.Display.V1.FormattedValue"
                          ],
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalRecords={total}
            recordsPerPage={recordsPerPage}
          />
        </div>
      );
    } else if (activeTab === "Trustees") {
      // SHOW LOADING SCREEN UNTIL DATA ARRIVES
      if (!trusteesData) {
        return (
          <div className={styles.loadingContainer}>
            <div className={styles.loadingImage}></div>
            <p className={styles.loadingText}>Loading...</p>
          </div>
        );
      }

      // TRUSTEE GROUPS
      const trusteeGroups = [
        { key: "all", label: "All Active Trustees" },
        { key: "payment", label: "Payment Trustees" },
        { key: "maintenance", label: "Maintenance Trustees" },
        { key: "finance", label: "Finance Trustees" },
        { key: "creditControl", label: "Credit Control Trustees" },
        { key: "commsConduct", label: "Communication & Conduct Trustees" },
        { key: "garden", label: "Garden Trustees" },
        { key: "security", label: "Security Trustees" },
      ];

      // --------------------------------------------------
      // COMPUTED FILTER + PAGINATION (GLOBAL FOR RETURN)
      // --------------------------------------------------

      const currentGroup = trusteesData[trusteeSubTab];
      const groupData = currentGroup?.value || [];

      const filtered = groupData.filter((t) => {
        const name = (
          trusteeDetails[t.contactid]?.yomifullname ||
          t.yomifullname ||
          t.fullname ||
          ""
        ).toLowerCase();

        const email = (
          trusteeDetails[t.contactid]?.emailaddress1 ||
          t.emailaddress1 ||
          t.email ||
          ""
        ).toLowerCase();

        const mobile = (
          trusteeDetails[t.contactid]?.mobilephone ||
          t.mobilephone ||
          t.mobile ||
          ""
        ).toLowerCase();

        return (
          (!trusteeFilterName ||
            name.includes(trusteeFilterName.toLowerCase())) &&
          (!trusteeFilterEmail ||
            email.includes(trusteeFilterEmail.toLowerCase())) &&
          (!trusteeFilterMobile ||
            mobile.includes(trusteeFilterMobile.toLowerCase()))
        );
      });

      const total = filtered.length;
      const paginated = filtered.slice(
        (trusteeCurrentPage - 1) * recordsPerPage,
        (trusteeCurrentPage - 1) * recordsPerPage + recordsPerPage,
      );

      // --------------------------------------------------
      // FINAL RETURN â€” TWO COLUMN LAYOUT
      // --------------------------------------------------

      return (
        <div className={styles.trusteesOuterContainer}>
          {/* MAIN WHITE CARD WITH TWO COLUMNS */}
          <div className={styles.trusteesCardTwoCol}>
            {/* LEFT VERTICAL SUBTABS â€” DESKTOP VIEW */}
            <div className={styles.trusteesLeftColumnDesktop}>
              {trusteeGroups.map((g) => {
                const active = g.key === trusteeSubTab;
                return (
                  <button
                    key={g.key}
                    className={
                      active
                        ? styles.trusteesLeftTabActive
                        : styles.trusteesLeftTab
                    }
                    onClick={() => {
                      setTrusteeSubTab(g.key);
                      setTrusteeCurrentPage(1);
                      setTrusteeFilterName("");
                      setTrusteeFilterEmail("");
                      setTrusteeFilterMobile("");
                    }}
                  >
                    {g.label}
                  </button>
                );
              })}
            </div>

            {/* MOBILE VERSION â€” DROPDOWN */}
            <div className={styles.trusteesLeftColumnMobile}>
              <select
                className={styles.trusteesMobileSelect}
                value={trusteeSubTab}
                onChange={(e) => {
                  setTrusteeSubTab(e.target.value);
                  setTrusteeCurrentPage(1);
                  setTrusteeFilterName("");
                  setTrusteeFilterEmail("");
                  setTrusteeFilterMobile("");
                }}
              >
                {trusteeGroups.map((g) => (
                  <option key={g.key} value={g.key}>
                    {g.label}
                  </option>
                ))}
              </select>
            </div>

            {/* RIGHT COLUMN â€” FILTERS + TABLE */}
            <div className={styles.trusteesRightColumn}>
              {/* TABLE */}
              <div className={styles.trusteesTableWrapper}>
                <table className={styles.dataTable}>
                  <thead>
                    <tr>
                      <th>Name:</th>
                      <th>Email:</th>
                      <th>Number:</th>
                    </tr>
                  </thead>

                  <tbody>
                    {paginated.map((t) => (
                      <tr key={t.contactid}>
                        <td>
                          {trusteeDetails[t.contactid]?.yomifullname ||
                            t.fullname}
                        </td>
                        <td>
                          {trusteeDetails[t.contactid]?.emailaddress1 ||
                            t.email}
                        </td>
                        <td>
                          {trusteeDetails[t.contactid]?.mobilephone || t.mobile}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <Pagination
                currentPage={trusteeCurrentPage}
                setCurrentPage={setTrusteeCurrentPage}
                totalRecords={total}
                recordsPerPage={recordsPerPage}
              />
            </div>
          </div>
        </div>
      );
    } else if (activeTab === "Finance") {
      if (!data || !data.value || data.value.length === 0)
        return (
          <div className={styles.errorText}>
            <p>No bank account details found.</p>
          </div>
        );

      const financeSubTabs = ["Bank Accounts"];
      return (
        <>
          <SubTabSelector
            tabs={financeSubTabs}
            activeTab={"Bank Accounts"}
            onSelect={() => {}}
          />
          <div>
            <div className={styles.responsiveTableWrapper}>
              <table className={styles.dataTable}>
                <thead>
                  <tr>
                    <th>Account Name</th>
                    <th>Bank Name</th>
                    <th>Account Number</th>
                    <th>Account Type</th>
                    <th>Last Recon Balance</th>
                    <th>Last Recon Date</th>
                  </tr>
                </thead>
                <tbody>
                  {data.value.map((item, index) => (
                    <tr key={index}>
                      <td>{item.cj_bankaccountname}</td>
                      <td>
                        {
                          item[
                            "_cj_bankname_value@OData.Community.Display.V1.FormattedValue"
                          ]
                        }
                      </td>
                      <td>{item.cj_accountnumber}</td>
                      <td>
                        {
                          item[
                            "cj_accounttype@OData.Community.Display.V1.FormattedValue"
                          ]
                        }
                      </td>
                      <td>
                        <span className={styles.amountCell}>
                          {formatAmount(item.cj_lastreconbalance)}
                        </span>
                      </td>
                      <td>{formatDate(item.cj_lastrecondate)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalRecords={data.value.length}
              recordsPerPage={recordsPerPage}
            />
          </div>
        </>
      );
    } else {
      return <p>Invalid Tab</p>;
    }
  };

  return (
    <div className={styles.page}>
      <header className={styles.topbar}>
        <div className={styles.topbarLeft}>
          <img src={logoimage} alt="GMA Logo" className={styles.topLogo} />

          {/* HAMBURGER: opens/closes sidebar */}
          <button
            type="button"
            className={styles.menuBtn}
            onClick={() => setSidebarOpen((v) => !v)}
          >
            ☰
          </button>

          <h1 className={styles.topTitle}>
            {buildingName ? `${buildingName} Information` : "Building Info"}
          </h1>
        </div>

        {/* USER CHIP: opens dropdown */}
        <div
          className={styles.userChip}
          onClick={() => {
            navigate("/user-profile");
          }}
          style={{ cursor: "pointer" }}
        >
          <span className={styles.statusDot}></span>
          <span className={styles.userName}>{displayName} ▾</span>
        </div>
      </header>

      {/* Sidebar + Main Content */}
      <div className={styles.shell}>
        <PortalSidebar
  activePortal="trustee"
  activeTab="buildings"
  userAccess={userAccess}
  loadingAccess={loadingAccess}
  sidebarOpen={sidebarOpen}
  ticketRole="trustee"
/>

        <main className={styles.contentArea}>
          <div className={styles.panel}>
            <div className={styles.subTabs}>
              {primaryTabs.map((tab) => (
                <button
                  key={tab}
                  className={`${styles.subTab} ${
                    activePrimaryTab === tab ? styles.subTabActive : ""
                  }`}
                  onClick={() => handlePrimaryTabChange(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>

            {activePrimaryTab === "Dashboards" && (
              <SubTabSelector
                tabs={dashboardTabs}
                activeTab={activeTab}
                onSelect={handleTabChange}
              />
            )}

            {activePrimaryTab === "Other" && (
              <SubTabSelector
                tabs={otherTabs}
                activeTab={activeTab}
                onSelect={handleTabChange}
              />
            )}

            {/* Fix here â€” render full dynamic content */}
            {renderTable()}
          </div>
        </main>
      </div>
    </div>
  );
};

export default BuildingInfoPage;
